<div
    class="section-padding-vertical-md lg:section-padding-vertical-lg w-full [&>h2]:text-3xl [&>h2]:mt-4 [&>h2]:mb-2 [&>h3]:mt-2 [&>h3]:mb-1 [&>h3]:text-xl">
    <h1 class="adsimple-113004805">Datenschutzerklärung</h1>
    <h2 id="einleitung-ueberblick" class="adsimple-113004805">Einleitung und Überblick</h2>
    <p>
        Wir haben diese Datenschutzerklärung (Fassung 02.06.2025-113004805) verfasst, um Ihnen gemäß
        der Vorgaben der
        <a
            class="adsimple-113004805"
            href="https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&amp;from=DE&amp;tid=113004805#d1e2269-1-1"
            target="_blank"
            rel="noopener"
            >Datenschutz-Grundverordnung (EU) 2016/679</a
        >
        und anwendbaren nationalen Gesetzen zu erklären, welche personenbezogenen Daten (kurz Daten)
        wir als Verantwortliche &#8211; und die von uns beauftragten Auftragsverarbeiter (z. B.
        Provider) &#8211; verarbeiten, zukünftig verarbeiten werden und welche rechtmäßigen
        Möglichkeiten Sie haben. Die verwendeten Begriffe sind geschlechtsneutral zu verstehen.<br />
        <strong class="adsimple-113004805">Kurz gesagt:</strong> Wir informieren Sie umfassend über
        Daten, die wir über Sie verarbeiten.
    </p>
    <p>
        Datenschutzerklärungen klingen für gewöhnlich sehr technisch und verwenden juristische
        Fachbegriffe. Diese Datenschutzerklärung soll Ihnen hingegen die wichtigsten Dinge so
        einfach und transparent wie möglich beschreiben. Soweit es der Transparenz förderlich ist,
        werden technische
        <strong class="adsimple-113004805">Begriffe leserfreundlich erklärt</strong>, Links zu
        weiterführenden Informationen geboten und
        <strong class="adsimple-113004805">Grafiken</strong> zum Einsatz gebracht. Wir informieren
        damit in klarer und einfacher Sprache, dass wir im Rahmen unserer Geschäftstätigkeiten nur
        dann personenbezogene Daten verarbeiten, wenn eine entsprechende gesetzliche Grundlage
        gegeben ist. Das ist sicher nicht möglich, wenn man möglichst knappe, unklare und
        juristisch-technische Erklärungen abgibt, so wie sie im Internet oft Standard sind, wenn es
        um Datenschutz geht. Ich hoffe, Sie finden die folgenden Erläuterungen interessant und
        informativ und vielleicht ist die eine oder andere Information dabei, die Sie noch nicht
        kannten.<br />
        Wenn trotzdem Fragen bleiben, möchten wir Sie bitten, sich an die unten bzw. im Impressum
        genannte verantwortliche Stelle zu wenden, den vorhandenen Links zu folgen und sich weitere
        Informationen auf Drittseiten anzusehen. Unsere Kontaktdaten finden Sie selbstverständlich
        auch im Impressum.
    </p>
    <h2 id="anwendungsbereich" class="adsimple-113004805">Anwendungsbereich</h2>
    <p>
        Diese Datenschutzerklärung gilt für alle von uns im Unternehmen verarbeiteten
        personenbezogenen Daten und für alle personenbezogenen Daten, die von uns beauftragte Firmen
        (Auftragsverarbeiter) verarbeiten. Mit personenbezogenen Daten meinen wir Informationen im
        Sinne des Art. 4 Nr. 1 DSGVO wie zum Beispiel Name, E-Mail-Adresse und postalische Anschrift
        einer Person. Die Verarbeitung personenbezogener Daten sorgt dafür, dass wir unsere
        Dienstleistungen und Produkte anbieten und abrechnen können, sei es online oder offline. Der
        Anwendungsbereich dieser Datenschutzerklärung umfasst:
    </p>
    <ul class="adsimple-113004805">
        <li class="adsimple-113004805">
            alle Onlineauftritte (Websites, Onlineshops), die wir betreiben
        </li>
        <li class="adsimple-113004805">Social Media Auftritte und E-Mail-Kommunikation</li>
        <li class="adsimple-113004805">mobile Apps für Smartphones und andere Geräte</li>
    </ul>
    <p>
        <strong class="adsimple-113004805">Kurz gesagt:</strong> Die Datenschutzerklärung gilt für
        alle Bereiche, in denen personenbezogene Daten im Unternehmen über die genannten Kanäle
        strukturiert verarbeitet werden. Sollten wir außerhalb dieser Kanäle mit Ihnen in
        Rechtsbeziehungen eintreten, werden wir Sie gegebenenfalls gesondert informieren.
    </p>
    <h2 id="rechtsgrundlagen" class="adsimple-113004805">Rechtsgrundlagen</h2>
    <p>
        In der folgenden Datenschutzerklärung geben wir Ihnen transparente Informationen zu den
        rechtlichen Grundsätzen und Vorschriften, also den Rechtsgrundlagen der
        Datenschutz-Grundverordnung, die uns ermöglichen, personenbezogene Daten zu verarbeiten.<br />
        Was das EU-Recht betrifft, beziehen wir uns auf die VERORDNUNG (EU) 2016/679 DES
        EUROPÄISCHEN PARLAMENTS UND DES RATES vom 27. April 2016. Diese Datenschutz-Grundverordnung
        der EU können Sie selbstverständlich online auf EUR-Lex, dem Zugang zum EU-Recht, unter
        <a
            class="adsimple-113004805"
            href="https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679"
            >https://eur-lex.europa.eu/legal-content/DE/ALL/?uri=celex%3A32016R0679</a
        >
        nachlesen.
    </p>
    <p>Wir verarbeiten Ihre Daten nur, wenn mindestens eine der folgenden Bedingungen zutrifft:</p>
    <ol>
        <li class="adsimple-113004805">
            <strong class="adsimple-113004805">Einwilligung</strong> (Artikel 6 Absatz 1 lit. a
            DSGVO): Sie haben uns Ihre Einwilligung gegeben, Daten zu einem bestimmten Zweck zu
            verarbeiten. Ein Beispiel wäre die Speicherung Ihrer eingegebenen Daten eines
            Kontaktformulars.
        </li>
        <li class="adsimple-113004805">
            <strong class="adsimple-113004805">Vertrag</strong> (Artikel 6 Absatz 1 lit. b DSGVO):
            Um einen Vertrag oder vorvertragliche Verpflichtungen mit Ihnen zu erfüllen, verarbeiten
            wir Ihre Daten. Wenn wir zum Beispiel einen Kaufvertrag mit Ihnen abschließen, benötigen
            wir vorab personenbezogene Informationen.
        </li>
        <li class="adsimple-113004805">
            <strong class="adsimple-113004805">Rechtliche Verpflichtung</strong> (Artikel 6 Absatz 1
            lit. c DSGVO): Wenn wir einer rechtlichen Verpflichtung unterliegen, verarbeiten wir
            Ihre Daten. Zum Beispiel sind wir gesetzlich verpflichtet Rechnungen für die Buchhaltung
            aufzuheben. Diese enthalten in der Regel personenbezogene Daten.
        </li>
        <li class="adsimple-113004805">
            <strong class="adsimple-113004805">Berechtigte Interessen</strong> (Artikel 6 Absatz 1
            lit. f DSGVO): Im Falle berechtigter Interessen, die Ihre Grundrechte nicht
            einschränken, behalten wir uns die Verarbeitung personenbezogener Daten vor. Wir müssen
            zum Beispiel gewisse Daten verarbeiten, um unsere Website sicher und wirtschaftlich
            effizient betreiben zu können. Diese Verarbeitung ist somit ein berechtigtes Interesse.
        </li>
    </ol>
    <p>
        Weitere Bedingungen wie die Wahrnehmung von Aufnahmen im öffentlichen Interesse und Ausübung
        öffentlicher Gewalt sowie dem Schutz lebenswichtiger Interessen treten bei uns in der Regel
        nicht auf. Soweit eine solche Rechtsgrundlage doch einschlägig sein sollte, wird diese an
        der entsprechenden Stelle ausgewiesen.
    </p>
    <p>Zusätzlich zu der EU-Verordnung gelten auch noch nationale Gesetze:</p>
    <ul class="adsimple-113004805">
        <li class="adsimple-113004805">
            In <strong class="adsimple-113004805">Österreich</strong> ist dies das Bundesgesetz zum
            Schutz natürlicher Personen bei der Verarbeitung personenbezogener Daten (<strong
                class="adsimple-113004805"
                >Datenschutzgesetz</strong
            >), kurz <strong class="adsimple-113004805">DSG</strong>.
        </li>
        <li class="adsimple-113004805">
            In <strong class="adsimple-113004805">Deutschland</strong> gilt das
            <strong class="adsimple-113004805">Bundesdatenschutzgesetz</strong>, kurz<strong
                class="adsimple-113004805">
                BDSG</strong
            >.
        </li>
    </ul>
    <p>
        Sofern weitere regionale oder nationale Gesetze zur Anwendung kommen, informieren wir Sie in
        den folgenden Abschnitten darüber.
    </p>
    <h2 id="kontaktdaten-verantwortliche" class="adsimple-113004805">
        Kontaktdaten des Verantwortlichen
    </h2>
    <p>
        Sollten Sie Fragen zum Datenschutz oder zur Verarbeitung personenbezogener Daten haben,
        finden Sie nachfolgend die Kontaktdaten des Verantwortlichen gemäß Artikel 4 Absatz 7
        EU-Datenschutz-Grundverordnung (DSGVO):<br />
        <span class="adsimple-113004805" style="font-weight: 400"
            >WeCodeIt OG<br />
            Hauptstraße 65<br />
            7023 Zemendorf</span
        >
    </p>
    <p>E-Mail: <a href="mailto:hello@wecodeit.at">hello&#64;wecodeit.at</a></p>
    <p>
        Impressum:
        <a href="https://www.wecodeit.at/impressum/">https://www.wecodeit.at/impressum/</a>
    </p>
    <h2 id="speicherdauer" class="adsimple-113004805">Speicherdauer</h2>
    <p>
        Dass wir personenbezogene Daten nur so lange speichern, wie es für die Bereitstellung
        unserer Dienstleistungen und Produkte unbedingt notwendig ist, gilt als generelles Kriterium
        bei uns. Das bedeutet, dass wir personenbezogene Daten löschen, sobald der Grund für die
        Datenverarbeitung nicht mehr vorhanden ist. In einigen Fällen sind wir gesetzlich dazu
        verpflichtet, bestimmte Daten auch nach Wegfall des ursprüngliches Zwecks zu speichern, zum
        Beispiel zu Zwecken der Buchführung.
    </p>
    <p>
        Sollten Sie die Löschung Ihrer Daten wünschen oder die Einwilligung zur Datenverarbeitung
        widerrufen, werden die Daten so rasch wie möglich und soweit keine Pflicht zur Speicherung
        besteht, gelöscht.
    </p>
    <p>
        Über die konkrete Dauer der jeweiligen Datenverarbeitung informieren wir Sie weiter unten,
        sofern wir weitere Informationen dazu haben.
    </p>
    <h2 id="rechte-dsgvo" class="adsimple-113004805">Rechte laut Datenschutz-Grundverordnung</h2>
    <p>
        Gemäß Artikel 13, 14 DSGVO informieren wir Sie über die folgenden Rechte, die Ihnen
        zustehen, damit es zu einer fairen und transparenten Verarbeitung von Daten kommt:
    </p>
    <ul class="adsimple-113004805">
        <li class="adsimple-113004805">
            Sie haben laut Artikel 15 DSGVO ein Auskunftsrecht darüber, ob wir Daten von Ihnen
            verarbeiten. Sollte das zutreffen, haben Sie Recht darauf eine Kopie der Daten zu
            erhalten und die folgenden Informationen zu erfahren:
            <ul class="adsimple-113004805">
                <li class="adsimple-113004805">
                    zu welchem Zweck wir die Verarbeitung durchführen;
                </li>
                <li class="adsimple-113004805">
                    die Kategorien, also die Arten von Daten, die verarbeitet werden;
                </li>
                <li class="adsimple-113004805">
                    wer diese Daten erhält und wenn die Daten an Drittländer übermittelt werden, wie
                    die Sicherheit garantiert werden kann;
                </li>
                <li class="adsimple-113004805">wie lange die Daten gespeichert werden;</li>
                <li class="adsimple-113004805">
                    das Bestehen des Rechts auf Berichtigung, Löschung oder Einschränkung der
                    Verarbeitung und dem Widerspruchsrecht gegen die Verarbeitung;
                </li>
                <li class="adsimple-113004805">
                    dass Sie sich bei einer Aufsichtsbehörde beschweren können (Links zu diesen
                    Behörden finden Sie weiter unten);
                </li>
                <li class="adsimple-113004805">
                    die Herkunft der Daten, wenn wir sie nicht bei Ihnen erhoben haben;
                </li>
                <li class="adsimple-113004805">
                    ob Profiling durchgeführt wird, ob also Daten automatisch ausgewertet werden, um
                    zu einem persönlichen Profil von Ihnen zu gelangen.
                </li>
            </ul>
        </li>
        <li class="adsimple-113004805">
            Sie haben laut Artikel 16 DSGVO ein Recht auf Berichtigung der Daten, was bedeutet, dass
            wir Daten richtig stellen müssen, falls Sie Fehler finden.
        </li>
        <li class="adsimple-113004805">
            Sie haben laut Artikel 17 DSGVO das Recht auf Löschung („Recht auf Vergessenwerden“),
            was konkret bedeutet, dass Sie die Löschung Ihrer Daten verlangen dürfen.
        </li>
        <li class="adsimple-113004805">
            Sie haben laut Artikel 18 DSGVO das Recht auf Einschränkung der Verarbeitung, was
            bedeutet, dass wir die Daten nur mehr speichern dürfen aber nicht weiter verwenden.
        </li>
        <li class="adsimple-113004805">
            Sie haben laut Artikel 20 DSGVO das Recht auf Datenübertragbarkeit, was bedeutet, dass
            wir Ihnen auf Anfrage Ihre Daten in einem gängigen Format zur Verfügung stellen.
        </li>
        <li class="adsimple-113004805">
            Sie haben laut Artikel 21 DSGVO ein Widerspruchsrecht, welches nach Durchsetzung eine
            Änderung der Verarbeitung mit sich bringt.
            <ul class="adsimple-113004805">
                <li class="adsimple-113004805">
                    Wenn die Verarbeitung Ihrer Daten auf Artikel 6 Abs. 1 lit. e (öffentliches
                    Interesse, Ausübung öffentlicher Gewalt) oder Artikel 6 Abs. 1 lit. f
                    (berechtigtes Interesse) basiert, können Sie gegen die Verarbeitung Widerspruch
                    einlegen. Wir prüfen danach so rasch wie möglich, ob wir diesem Widerspruch
                    rechtlich nachkommen können.
                </li>
                <li class="adsimple-113004805">
                    Werden Daten verwendet, um Direktwerbung zu betreiben, können Sie jederzeit
                    gegen diese Art der Datenverarbeitung widersprechen. Wir dürfen Ihre Daten
                    danach nicht mehr für Direktmarketing verwenden.
                </li>
                <li class="adsimple-113004805">
                    Werden Daten verwendet, um Profiling zu betreiben, können Sie jederzeit gegen
                    diese Art der Datenverarbeitung widersprechen. Wir dürfen Ihre Daten danach
                    nicht mehr für Profiling verwenden.
                </li>
            </ul>
        </li>
        <li class="adsimple-113004805">
            Sie haben laut Artikel 22 DSGVO unter Umständen das Recht, nicht einer ausschließlich
            auf einer automatisierten Verarbeitung (zum Beispiel Profiling) beruhenden Entscheidung
            unterworfen zu werden.
        </li>
        <li class="adsimple-113004805">
            Sie haben laut Artikel 77 DSGVO das Recht auf Beschwerde. Das heißt, Sie können sich
            jederzeit bei der Datenschutzbehörde beschweren, wenn Sie der Meinung sind, dass die
            Datenverarbeitung von personenbezogenen Daten gegen die DSGVO verstößt.
        </li>
    </ul>
    <p>
        <strong class="adsimple-113004805">Kurz gesagt:</strong> Sie haben Rechte &#8211; zögern Sie
        nicht, die oben gelistete verantwortliche Stelle bei uns zu kontaktieren!
    </p>
    <p>
        Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder
        Ihre datenschutzrechtlichen Ansprüche in sonst einer Weise verletzt worden sind, können Sie
        sich bei der Aufsichtsbehörde beschweren. Diese ist für Österreich die Datenschutzbehörde,
        deren Website Sie unter
        <a
            class="adsimple-113004805"
            href="https://www.dsb.gv.at/?tid=113004805"
            target="_blank"
            rel="noopener"
            >https://www.dsb.gv.at/</a
        >
        finden. In Deutschland gibt es für jedes Bundesland einen Datenschutzbeauftragten. Für
        nähere Informationen können Sie sich an die
        <a
            class="adsimple-113004805"
            href="https://www.bfdi.bund.de/DE/Home/home_node.html"
            target="_blank"
            rel="noopener"
            >Bundesbeauftragte für den Datenschutz und die Informationsfreiheit (BfDI)</a
        >
        wenden. Für unser Unternehmen ist die folgende lokale Datenschutzbehörde zuständig:
    </p>
    <h2 id="sicherheit-datenverarbeitung" class="adsimple-113004805">
        Sicherheit der Datenverarbeitung
    </h2>
    <p>
        Um personenbezogene Daten zu schützen, haben wir sowohl technische als auch organisatorische
        Maßnahmen umgesetzt. Wo es uns möglich ist, verschlüsseln oder pseudonymisieren wir
        personenbezogene Daten. Dadurch machen wir es im Rahmen unserer Möglichkeiten so schwer wie
        möglich, dass Dritte aus unseren Daten auf persönliche Informationen schließen können.
    </p>
    <p>
        Art. 25 DSGVO spricht hier von &#8220;Datenschutz durch Technikgestaltung und durch
        datenschutzfreundliche Voreinstellungen&#8221; und meint damit, dass man sowohl bei Software
        (z. B. Formularen) also auch Hardware (z. B. Zugang zum Serverraum) immer an Sicherheit
        denkt und entsprechende Maßnahmen setzt. Im Folgenden gehen wir, falls erforderlich, noch
        auf konkrete Maßnahmen ein.
    </p>
    <h2 id="tls-verschluesselung-https" class="adsimple-113004805">
        TLS-Verschlüsselung mit https
    </h2>
    <p>
        TLS, Verschlüsselung und https klingen sehr technisch und sind es auch. Wir verwenden HTTPS
        (das Hypertext Transfer Protocol Secure steht für „sicheres
        Hypertext-Übertragungsprotokoll“), um Daten abhörsicher im Internet zu übertragen.<br />
        Das bedeutet, dass die komplette Übertragung aller Daten von Ihrem Browser zu unserem
        Webserver abgesichert ist &#8211; niemand kann &#8220;mithören&#8221;.
    </p>
    <p>
        Damit haben wir eine zusätzliche Sicherheitsschicht eingeführt und erfüllen den Datenschutz
        durch Technikgestaltung (<a
            class="adsimple-113004805"
            href="https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&amp;from=DE&amp;tid=113004805"
            target="_blank"
            rel="noopener"
            >Artikel 25 Absatz 1 DSGVO</a
        >). Durch den Einsatz von TLS (Transport Layer Security), einem Verschlüsselungsprotokoll
        zur sicheren Datenübertragung im Internet, können wir den Schutz vertraulicher Daten
        sicherstellen.<br />
        Sie erkennen die Benutzung dieser Absicherung der Datenübertragung am kleinen Schlosssymbol
        <img
            role="img"
            src="https://www.adsimple.at/wp-content/uploads/2018/03/schlosssymbol-https.svg"
            width="17"
            height="18" />
        links oben im Browser, links von der Internetadresse (z. B. beispielseite.de) und der
        Verwendung des Schemas https (anstatt http) als Teil unserer Internetadresse.<br />
        Wenn Sie mehr zum Thema Verschlüsselung wissen möchten, empfehlen wir die Google Suche nach
        &#8220;Hypertext Transfer Protocol Secure wiki&#8221; um gute Links zu weiterführenden
        Informationen zu erhalten.
    </p>
    <h2 id="kommunikation" class="adsimple-113004805">Kommunikation</h2>
    <table border="1" cellpadding="15">
        <tbody>
            <tr>
                <td>
                    <strong class="adsimple-113004805">Kommunikation Zusammenfassung</strong>
                    <br />
                    &#x1f465; Betroffene: Alle, die mit uns per Telefon, E-Mail oder Online-Formular
                    kommunizieren<br />
                    &#x1f4d3; Verarbeitete Daten: z. B. Telefonnummer, Name, E-Mail-Adresse,
                    eingegebene Formulardaten. Mehr Details dazu finden Sie bei der jeweils
                    eingesetzten Kontaktart<br />
                    &#x1f91d; Zweck: Abwicklung der Kommunikation mit Kunden, Geschäftspartnern
                    usw.<br />
                    &#x1f4c5; Speicherdauer: Dauer des Geschäftsfalls und der gesetzlichen
                    Vorschriften<br />
                    &#x2696;&#xfe0f; Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung),
                    Art. 6 Abs. 1 lit. b DSGVO (Vertrag), Art. 6 Abs. 1 lit. f DSGVO (Berechtigte
                    Interessen)
                </td>
            </tr>
        </tbody>
    </table>
    <p>
        Wenn Sie mit uns Kontakt aufnehmen und per Telefon, E-Mail oder Online-Formular
        kommunizieren, kann es zur Verarbeitung personenbezogener Daten kommen.
    </p>
    <p>
        Die Daten werden für die Abwicklung und Bearbeitung Ihrer Frage und des damit
        zusammenhängenden Geschäftsvorgangs verarbeitet. Die Daten während eben solange gespeichert
        bzw. solange es das Gesetz vorschreibt.
    </p>
    <h3 class="adsimple-113004805">Betroffene Personen</h3>
    <p>
        Von den genannten Vorgängen sind alle betroffen, die über die von uns bereit gestellten
        Kommunikationswege den Kontakt zu uns suchen.
    </p>
    <h3 class="adsimple-113004805">Telefon</h3>
    <p>
        Wenn Sie uns anrufen, werden die Anrufdaten auf dem jeweiligen Endgerät und beim
        eingesetzten Telekommunikationsanbieter pseudonymisiert gespeichert. Außerdem können Daten
        wie Name und Telefonnummer im Anschluss per E-Mail versendet und zur Anfragebeantwortung
        gespeichert werden. Die Daten werden gelöscht, sobald der Geschäftsfall beendet wurde und es
        gesetzliche Vorgaben erlauben.
    </p>
    <h3 class="adsimple-113004805">E-Mail</h3>
    <p>
        Wenn Sie mit uns per E-Mail kommunizieren, werden Daten gegebenenfalls auf dem jeweiligen
        Endgerät (Computer, Laptop, Smartphone,&#8230;) gespeichert und es kommt zur Speicherung von
        Daten auf dem E-Mail-Server. Die Daten werden gelöscht, sobald der Geschäftsfall beendet
        wurde und es gesetzliche Vorgaben erlauben.
    </p>
    <h3 class="adsimple-113004805">Online Formulare</h3>
    <p>
        Wenn Sie mit uns mittels Online-Formular kommunizieren, werden Daten auf unserem Webserver
        gespeichert und gegebenenfalls an eine E-Mail-Adresse von uns weitergeleitet. Die Daten
        werden gelöscht, sobald der Geschäftsfall beendet wurde und es gesetzliche Vorgaben
        erlauben.
    </p>
    <h3 class="adsimple-113004805">Rechtsgrundlagen</h3>
    <p>Die Verarbeitung der Daten basiert auf den folgenden Rechtsgrundlagen:</p>
    <ul class="adsimple-113004805">
        <li class="adsimple-113004805">
            Art. 6 Abs. 1 lit. a DSGVO (Einwilligung): Sie geben uns die Einwilligung Ihre Daten zu
            speichern und weiter für den Geschäftsfall betreffende Zwecke zu verwenden;
        </li>
        <li class="adsimple-113004805">
            Art. 6 Abs. 1 lit. b DSGVO (Vertrag): Es besteht die Notwendigkeit für die Erfüllung
            eines Vertrags mit Ihnen oder einem Auftragsverarbeiter wie z. B. dem Telefonanbieter
            oder wir müssen die Daten für vorvertragliche Tätigkeiten, wie z. B. die Vorbereitung
            eines Angebots, verarbeiten;
        </li>
        <li class="adsimple-113004805">
            Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen): Wir wollen Kundenanfragen und
            geschäftliche Kommunikation in einem professionellen Rahmen betreiben. Dazu sind gewisse
            technische Einrichtungen wie z. B. E-Mail-Programme, Exchange-Server und
            Mobilfunkbetreiber notwendig, um die Kommunikation effizient betreiben zu können.
        </li>
    </ul>
    <h2 id="auftragsverarbeitungsvertrag-avv" class="adsimple-113004805">
        Auftragsverarbeitungsvertrag (AVV)
    </h2>
    <p>
        In diesem Abschnitt möchten wir Ihnen erklären, was ein Auftragsverarbeitungsvertrag ist und
        warum dieser benötigt wird. Weil das Wort &#8220;Auftragsverarbeitungsvertrag&#8221; ein
        ziemlicher Zungenbrecher ist, werden wir hier im Text auch öfters nur das Akronym AVV
        benutzen. Wie die meisten Unternehmen arbeiten wir nicht alleine, sondern nehmen auch selbst
        Dienstleistungen anderer Unternehmen oder Einzelpersonen in Anspruch.  Durch die
        Einbeziehung verschiedener Unternehmen bzw. Dienstleister kann es sein, dass wir 
        personenbezogene Daten zur Verarbeitung weitergeben. Diese Partner fungieren dann als
        Auftragsverarbeiter, mit denen wir einen Vertrag, den sogenannten
        Auftragsverarbeitungsvertrag (AVV), abschließen. Für Sie am wichtigsten zu wissen ist, dass
        die Verarbeitung Ihrer personenbezogenen Daten ausschließlich nach unserer Weisung erfolgt
        und durch den AVV geregelt werden muss.
    </p>
    <h3 class="adsimple-113004805">Wer sind Auftragsverarbeiter?</h3>
    <p>
        Wir sind als Unternehmen und Websiteinhaber für alle Daten, die wir von Ihnen verarbeiten
        verantwortlich. Neben den Verantwortlichen kann es auch sogenannte Auftragsverarbeiter
        geben. Dazu zählt jedes Unternehmen bzw. jede Person, die in unserem Auftrag
        personenbezogene Daten verarbeitet. Genauer und nach der DSGVO-Definition gesagt: jede
        natürliche oder juristische Person, Behörde, Einrichtung oder eine andere Stelle, die in
        unserem Auftrag personenbezogene Daten verarbeitet, gilt als Auftragsverarbeiter.
        Auftragsverarbeiter können folglich Dienstleister wie Hosting- oder Cloudanbieter,
        Bezahlungs- oder Newsletter-Anbieter oder große Unternehmen wie beispielsweise Google oder
        Microsoft sein.
    </p>
    <p>
        Zur besseren Verständlichkeit der Begrifflichkeiten hier ein Überblick über die drei Rollen
        in der DSGVO:
    </p>
    <p>
        <strong class="adsimple-113004805">Betroffener</strong> (Sie als Kunde oder Interessent) →
        <strong class="adsimple-113004805">Verantwortlicher</strong> (wir als Unternehmen und
        Auftraggeber) →
        <strong class="adsimple-113004805">Auftragsverarbeiter</strong> (Dienstleister wie z. B.
        Webhoster oder Cloudanbieter)
    </p>
    <h3 class="adsimple-113004805">Inhalt eines Auftragsverarbeitungsvertrages</h3>
    <p>
        Wie bereits oben erwähnt, haben wir mit unseren Partnern, die als Auftragsverarbeiter
        fungieren, einen AVV abgeschlossen. Darin wird allen voran festgehalten, dass der
        Auftragsverarbeiter die zu bearbeitenden Daten ausschließlich gemäß der DSGVO verarbeitet.
        Der Vertrag muss schriftlich abgeschlossen werden, allerdings gilt in diesem Zusammenhang
        auch der elektronische Vertragsabschluss als „schriftlich“. Erst auf der Grundlage des
        Vertrags erfolgt die Verarbeitung der personenbezogenen Daten. Im Vertrag muss folgendes
        enthalten sein:
    </p>
    <ul class="adsimple-113004805">
        <li class="adsimple-113004805">Bindung an uns als Verantwortlichen</li>
        <li class="adsimple-113004805">Pflichten und Rechte des Verantwortlichen</li>
        <li class="adsimple-113004805">Kategorien betroffener Personen</li>
        <li class="adsimple-113004805">Art der personenbezogenen Daten</li>
        <li class="adsimple-113004805">Art und Zweck der Datenverarbeitung</li>
        <li class="adsimple-113004805">Gegenstand und Dauer der Datenverarbeitung</li>
        <li class="adsimple-113004805">Durchführungsort der Datenverarbeitung</li>
    </ul>
    <p>
        Weiters enthält der Vertrag alle Pflichten des Auftragsverarbeiters. Die wichtigsten
        Pflichten sind:
    </p>
    <ul class="adsimple-113004805">
        <li class="adsimple-113004805">Maßnahmen zur Datensicherheit zu gewährleisten</li>
        <li class="adsimple-113004805">
            mögliche technische und organisatorischen Maßnahmen zu treffen, um die Rechte der
            betroffenen Person zu schützen
        </li>
        <li class="adsimple-113004805">ein Daten-Verarbeitungsverzeichnis zu führen</li>
        <li class="adsimple-113004805">
            auf Anfrage der Datenschutz-Aufsichtsbehörde mit dieser zusammenzuarbeiten
        </li>
        <li class="adsimple-113004805">
            eine Risikoanalyse in Bezug auf die erhaltenen personenbezogenen Daten durchzuführen
        </li>
        <li class="adsimple-113004805">
            Sub-Auftragsverarbeiter dürfen nur mit schriftlicher Genehmigung des Verantwortlichen
            beauftragt werden
        </li>
    </ul>
    <p>
        Wie so eine AVV konkret aussieht, können Sie sich beispielsweise unter
        <a
            class="adsimple-113004805"
            href="https://www.wko.at/service/wirtschaftsrecht-gewerberecht/eu-dsgvo-mustervertrag-auftragsverarbeitung.html"
            >https://www.wko.at/service/wirtschaftsrecht-gewerberecht/eu-dsgvo-mustervertrag-auftragsverarbeitung.html</a
        >
        ansehen. Hier wird ein Mustervertrag vorgestellt.
    </p>
    <h2 id="cookies" class="adsimple-113004805">Cookies</h2>
    <table border="1" cellpadding="15">
        <tbody>
            <tr>
                <td>
                    <strong class="adsimple-113004805">Cookies Zusammenfassung</strong>
                    <br />
                    &#x1f465; Betroffene: Besucher der Website<br />
                    &#x1f91d; Zweck: abhängig vom jeweiligen Cookie. Mehr Details dazu finden Sie
                    weiter unten bzw. beim Hersteller der Software, der das Cookie setzt.<br />
                    &#x1f4d3; Verarbeitete Daten: Abhängig vom jeweils eingesetzten Cookie. Mehr
                    Details dazu finden Sie weiter unten bzw. beim Hersteller der Software, der das
                    Cookie setzt.<br />
                    &#x1f4c5; Speicherdauer: abhängig vom jeweiligen Cookie, kann von Stunden bis
                    hin zu Jahren variieren<br />
                    &#x2696;&#xfe0f; Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung),
                    Art. 6 Abs. 1 lit.f DSGVO (Berechtigte Interessen)
                </td>
            </tr>
        </tbody>
    </table>
    <h3 class="adsimple-113004805">Was sind Cookies?</h3>
    <p>
        Unsere Website verwendet HTTP-Cookies, um nutzerspezifische Daten zu speichern.<br />
        Im Folgenden erklären wir, was Cookies sind und warum Sie genutzt werden, damit Sie die
        folgende Datenschutzerklärung besser verstehen.
    </p>
    <p>
        Immer wenn Sie durch das Internet surfen, verwenden Sie einen Browser. Bekannte Browser sind
        beispielsweise Chrome, Safari, Firefox, Internet Explorer und Microsoft Edge. Die meisten
        Websites speichern kleine Text-Dateien in Ihrem Browser. Diese Dateien nennt man Cookies.
    </p>
    <p>
        Eines ist nicht von der Hand zu weisen: Cookies sind echt nützliche Helferlein. Fast alle
        Websites verwenden Cookies. Genauer gesprochen sind es HTTP-Cookies, da es auch noch andere
        Cookies für andere Anwendungsbereiche gibt. HTTP-Cookies sind kleine Dateien, die von
        unserer Website auf Ihrem Computer gespeichert werden. Diese Cookie-Dateien werden
        automatisch im Cookie-Ordner, quasi dem &#8220;Hirn&#8221; Ihres Browsers, untergebracht.
        Ein Cookie besteht aus einem Namen und einem Wert. Bei der Definition eines Cookies müssen
        zusätzlich ein oder mehrere Attribute angegeben werden.
    </p>
    <p>
        Cookies speichern gewisse Nutzerdaten von Ihnen, wie beispielsweise Sprache oder persönliche
        Seiteneinstellungen. Wenn Sie unsere Seite wieder aufrufen, übermittelt Ihr Browser die
        „userbezogenen“ Informationen an unsere Seite zurück. Dank der Cookies weiß unsere Website,
        wer Sie sind und bietet Ihnen die Einstellung, die Sie gewohnt sind. In einigen Browsern hat
        jedes Cookie eine eigene Datei, in anderen wie beispielsweise Firefox sind alle Cookies in
        einer einzigen Datei gespeichert.
    </p>
    <p>
        Die folgende Grafik zeigt eine mögliche Interaktion zwischen einem Webbrowser wie z. B.
        Chrome und dem Webserver. Dabei fordert der Webbrowser eine Website an und erhält vom Server
        ein Cookie zurück, welches der Browser erneut verwendet, sobald eine andere Seite
        angefordert wird.
    </p>
    <p>
        <img
            role="img"
            src="https://www.adsimple.at/wp-content/uploads/2018/03/http-cookie-interaction.svg"
            alt="HTTP Cookie Interaktion zwischen Browser und Webserver"
            width="100%" />
    </p>
    <p>
        Es gibt sowohl Erstanbieter Cookies als auch Drittanbieter-Cookies. Erstanbieter-Cookies
        werden direkt von unserer Seite erstellt, Drittanbieter-Cookies werden von Partner-Websites
        (z.B. Google Analytics) erstellt. Jedes Cookie ist individuell zu bewerten, da jedes Cookie
        andere Daten speichert. Auch die Ablaufzeit eines Cookies variiert von ein paar Minuten bis
        hin zu ein paar Jahren. Cookies sind keine Software-Programme und enthalten keine Viren,
        Trojaner oder andere „Schädlinge“. Cookies können auch nicht auf Informationen Ihres PCs
        zugreifen.
    </p>
    <p>So können zum Beispiel Cookie-Daten aussehen:</p>
    <p>
        <strong class="adsimple-113004805">Name:</strong> _ga<br />
        <strong class="adsimple-113004805">Wert:</strong> GA1.2.1326744211.152113004805-9<br />
        <strong class="adsimple-113004805">Verwendungszweck:</strong> Unterscheidung der
        Websitebesucher<br />
        <strong class="adsimple-113004805">Ablaufdatum:</strong> nach 2 Jahren
    </p>
    <p>Diese Mindestgrößen sollte ein Browser unterstützen können:</p>
    <ul class="adsimple-113004805">
        <li class="adsimple-113004805">Mindestens 4096 Bytes pro Cookie</li>
        <li class="adsimple-113004805">Mindestens 50 Cookies pro Domain</li>
        <li class="adsimple-113004805">Mindestens 3000 Cookies insgesamt</li>
    </ul>
    <h3 class="adsimple-113004805">Welche Arten von Cookies gibt es?</h3>
    <p>
        Die Frage welche Cookies wir im Speziellen verwenden, hängt von den verwendeten Diensten ab
        und wird in den folgenden Abschnitten der Datenschutzerklärung geklärt. An dieser Stelle
        möchten wir kurz auf die verschiedenen Arten von HTTP-Cookies eingehen.
    </p>
    <p>Man kann 4 Arten von Cookies unterscheiden:</p>
    <p>
        <strong class="adsimple-113004805">Unerlässliche Cookies<br /> </strong>Diese Cookies sind
        nötig, um grundlegende Funktionen der Website sicherzustellen. Zum Beispiel braucht es diese
        Cookies, wenn ein User ein Produkt in den Warenkorb legt, dann auf anderen Seiten
        weitersurft und später erst zur Kasse geht. Durch diese Cookies wird der Warenkorb nicht
        gelöscht, selbst wenn der User sein Browserfenster schließt.
    </p>
    <p>
        <strong class="adsimple-113004805">Zweckmäßige Cookies<br /> </strong>Diese Cookies sammeln
        Infos über das Userverhalten und ob der User etwaige Fehlermeldungen bekommt. Zudem werden
        mithilfe dieser Cookies auch die Ladezeit und das Verhalten der Website bei verschiedenen
        Browsern gemessen.
    </p>
    <p>
        <strong class="adsimple-113004805">Zielorientierte Cookies<br /> </strong>Diese Cookies
        sorgen für eine bessere Nutzerfreundlichkeit. Beispielsweise werden eingegebene Standorte,
        Schriftgrößen oder Formulardaten gespeichert.
    </p>
    <p>
        <strong class="adsimple-113004805">Werbe-Cookies<br /> </strong>Diese Cookies werden auch
        Targeting-Cookies genannt. Sie dienen dazu dem User individuell angepasste Werbung zu
        liefern. Das kann sehr praktisch, aber auch sehr nervig sein.
    </p>
    <p>
        Üblicherweise werden Sie beim erstmaligen Besuch einer Website gefragt, welche dieser
        Cookiearten Sie zulassen möchten. Und natürlich wird diese Entscheidung auch in einem Cookie
        gespeichert.
    </p>
    <p>
        Wenn Sie mehr über Cookies wissen möchten und technische Dokumentationen nicht scheuen,
        empfehlen wir
        <a class="adsimple-113004805" href="https://datatracker.ietf.org/doc/html/rfc6265"
            >https://datatracker.ietf.org/doc/html/rfc6265</a
        >, dem Request for Comments der Internet Engineering Task Force (IETF) namens &#8220;HTTP
        State Management Mechanism&#8221;.
    </p>
    <h3 class="adsimple-113004805">Zweck der Verarbeitung über Cookies</h3>
    <p>
        Der Zweck ist letztendlich abhängig vom jeweiligen Cookie. Mehr Details dazu finden Sie
        weiter unten bzw. beim Hersteller der Software, die das Cookie setzt.
    </p>
    <h3 class="adsimple-113004805">Welche Daten werden verarbeitet?</h3>
    <p>
        Cookies sind kleine Gehilfen für eine viele verschiedene Aufgaben. Welche Daten in Cookies
        gespeichert werden, kann man leider nicht verallgemeinern, aber wir werden Sie im Rahmen der
        folgenden Datenschutzerklärung über die verarbeiteten bzw. gespeicherten Daten informieren.
    </p>
    <h3 class="adsimple-113004805">Speicherdauer von Cookies</h3>
    <p>
        Die Speicherdauer hängt vom jeweiligen Cookie ab und wird weiter unter präzisiert. Manche
        Cookies werden nach weniger als einer Stunde gelöscht, andere können mehrere Jahre auf einem
        Computer gespeichert bleiben.
    </p>
    <p>
        Sie haben außerdem selbst Einfluss auf die Speicherdauer. Sie können über ihren Browser
        sämtliche Cookies jederzeit manuell löschen (siehe auch unten
        &#8220;Widerspruchsrecht&#8221;). Ferner werden Cookies, die auf einer Einwilligung beruhen,
        spätestens nach Widerruf Ihrer Einwilligung gelöscht, wobei die Rechtmäßigkeit der
        Speicherung bis dahin unberührt bleibt.
    </p>
    <h3 class="adsimple-113004805">Widerspruchsrecht &#8211; wie kann ich Cookies löschen?</h3>
    <p>
        Wie und ob Sie Cookies verwenden wollen, entscheiden Sie selbst. Unabhängig von welchem
        Service oder welcher Website die Cookies stammen, haben Sie immer die Möglichkeit Cookies zu
        löschen, zu deaktivieren oder nur teilweise zuzulassen. Zum Beispiel können Sie Cookies von
        Drittanbietern blockieren, aber alle anderen Cookies zulassen.
    </p>
    <p>
        Wenn Sie feststellen möchten, welche Cookies in Ihrem Browser gespeichert wurden, wenn Sie
        Cookie-Einstellungen ändern oder löschen wollen, können Sie dies in Ihren
        Browser-Einstellungen finden:
    </p>
    <p>
        <a
            class="adsimple-113004805"
            href="https://support.google.com/chrome/answer/95647?tid=113004805"
            target="_blank"
            rel="noopener noreferrer"
            >Chrome: Cookies in Chrome löschen, aktivieren und verwalten</a
        >
    </p>
    <p>
        <a
            class="adsimple-113004805"
            href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=113004805"
            target="_blank"
            rel="noopener noreferrer"
            >Safari: Verwalten von Cookies und Websitedaten mit Safari</a
        >
    </p>
    <p>
        <a
            class="adsimple-113004805"
            href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=113004805"
            target="_blank"
            rel="noopener noreferrer"
            >Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf Ihrem Computer
            abgelegt haben</a
        >
    </p>
    <p>
        <a
            class="adsimple-113004805"
            href="https://support.microsoft.com/de-de/windows/l%C3%B6schen-und-verwalten-von-cookies-168dab11-0753-043d-7c16-ede5947fc64d?tid=113004805"
            >Internet Explorer: Löschen und Verwalten von Cookies</a
        >
    </p>
    <p>
        <a
            class="adsimple-113004805"
            href="https://support.microsoft.com/de-de/microsoft-edge/cookies-in-microsoft-edge-l%C3%B6schen-63947406-40ac-c3b8-57b9-2a946a29ae09?tid=113004805"
            >Microsoft Edge: Löschen und Verwalten von Cookies</a
        >
    </p>
    <p>
        Falls Sie grundsätzlich keine Cookies haben wollen, können Sie Ihren Browser so einrichten,
        dass er Sie immer informiert, wenn ein Cookie gesetzt werden soll. So können Sie bei jedem
        einzelnen Cookie entscheiden, ob Sie das Cookie erlauben oder nicht. Die Vorgangsweise ist
        je nach Browser verschieden. Am besten Sie suchen die Anleitung in Google mit dem
        Suchbegriff “Cookies löschen Chrome” oder &#8220;Cookies deaktivieren Chrome&#8221; im Falle
        eines Chrome Browsers.
    </p>
    <h3 class="adsimple-113004805">Rechtsgrundlage</h3>
    <p>
        Seit 2009 gibt es die sogenannten „Cookie-Richtlinien“. Darin ist festgehalten, dass das
        Speichern von Cookies eine <strong class="adsimple-113004805">Einwilligung</strong> (Artikel
        6 Abs. 1 lit. a DSGVO) von Ihnen verlangt. Innerhalb der EU-Länder gibt es allerdings noch
        sehr unterschiedliche Reaktionen auf diese Richtlinien. In Österreich erfolgte aber die
        Umsetzung dieser Richtlinie in § 165 Abs. 3 des Telekommunikationsgesetzes (2021). In
        Deutschland wurden die Cookie-Richtlinien nicht als nationales Recht umgesetzt. Stattdessen
        erfolgte die Umsetzung dieser Richtlinie weitgehend in § 15 Abs. 3 des Telemediengesetzes
        (TMG), welches seit Mai 2024 durch das Digitale-Dienste-Gesetz (DDG) ersetzt wurde.
    </p>
    <p>
        Für unbedingt notwendige Cookies, auch soweit keine Einwilligung vorliegt, bestehen
        <strong class="adsimple-113004805">berechtigte Interessen</strong> (Artikel 6 Abs. 1 lit. f
        DSGVO), die in den meisten Fällen wirtschaftlicher Natur sind. Wir möchten den Besuchern der
        Website eine angenehme Benutzererfahrung bescheren und dafür sind bestimmte Cookies oft
        unbedingt notwendig.
    </p>
    <p>
        Soweit nicht unbedingt erforderliche Cookies zum Einsatz kommen, geschieht dies nur im Falle
        Ihrer Einwilligung. Rechtsgrundlage ist insoweit Art. 6 Abs. 1 lit. a DSGVO.
    </p>
    <p>
        In den folgenden Abschnitten werden Sie genauer über den Einsatz von Cookies informiert,
        sofern eingesetzte Software Cookies verwendet.
    </p>
    <h2 id="webhosting-einleitung" class="adsimple-113004805">Webhosting Einleitung</h2>
    <table border="1" cellpadding="15">
        <tbody>
            <tr>
                <td>
                    <strong class="adsimple-113004805">Webhosting Zusammenfassung</strong>
                    <br />
                    &#x1f465; Betroffene: Besucher der Website<br />
                    &#x1f91d; Zweck: professionelles Hosting der Website und Absicherung des
                    Betriebs<br />
                    &#x1f4d3; Verarbeitete Daten: IP-Adresse, Zeitpunkt des Websitebesuchs,
                    verwendeter Browser und weitere Daten. Mehr Details dazu finden Sie weiter unten
                    bzw. beim jeweils eingesetzten Webhosting Provider.<br />
                    &#x1f4c5; Speicherdauer: abhängig vom jeweiligen Provider, aber in der Regel 2
                    Wochen<br />
                    &#x2696;&#xfe0f; Rechtsgrundlagen: Art. 6 Abs. 1 lit.f DSGVO (Berechtigte
                    Interessen)
                </td>
            </tr>
        </tbody>
    </table>
    <h3 class="adsimple-113004805">Was ist Webhosting?</h3>
    <p>
        Wenn Sie heutzutage Websites besuchen, werden gewisse Informationen &#8211; auch
        personenbezogene Daten &#8211; automatisch erstellt und gespeichert, so auch auf dieser
        Website. Diese Daten sollten möglichst sparsam und nur mit Begründung verarbeitet werden.
        Mit Website meinen wir übrigens die Gesamtheit aller Webseiten auf einer Domain, d.h. alles
        von der Startseite (Homepage) bis hin zur aller letzten Unterseite (wie dieser hier). Mit
        Domain meinen wir zum Beispiel beispiel.de oder musterbeispiel.com.
    </p>
    <p>
        Wenn Sie eine Website auf einem Computer, Tablet oder Smartphone ansehen möchten, verwenden
        Sie dafür ein Programm, das sich Webbrowser nennt. Sie kennen vermutlich einige Webbrowser
        beim Namen: Google Chrome, Microsoft Edge, Mozilla Firefox und Apple Safari. Wir sagen kurz
        Browser oder Webbrowser dazu.
    </p>
    <p>
        Um die Website anzuzeigen, muss sich der Browser zu einem anderen Computer verbinden, wo der
        Code der Website gespeichert ist: dem Webserver. Der Betrieb eines Webservers ist eine
        komplizierte und aufwendige Aufgabe, weswegen dies in der Regel von professionellen
        Anbietern, den Providern, übernommen wird. Diese bieten Webhosting an und sorgen damit für
        eine verlässliche und fehlerfreie Speicherung der Daten von Websites. Eine ganze Menge
        Fachbegriffe, aber bitte bleiben Sie dran, es wird noch besser!
    </p>
    <p>
        Bei der Verbindungsaufnahme des Browsers auf Ihrem Computer (Desktop, Laptop, Tablet oder
        Smartphone) und während der Datenübertragung zu und vom Webserver kann es zu einer
        Verarbeitung personenbezogener Daten kommen. Einerseits speichert Ihr Computer Daten,
        andererseits muss auch der Webserver Daten eine Zeit lang speichern, um einen ordentlichen
        Betrieb zu gewährleisten.
    </p>
    <p>
        Ein Bild sagt mehr als tausend Worte, daher zeigt folgende Grafik zur Veranschaulichung das
        Zusammenspiel zwischen Browser, dem Internet und dem Hosting-Provider.
    </p>
    <p>
        <img
            role="img"
            src="https://www.adsimple.at/wp-content/uploads/2018/03/browser-und-webserver.svg"
            alt="Browser und Webserver"
            width="100%" />
    </p>
    <h3 class="adsimple-113004805">Warum verarbeiten wir personenbezogene Daten?</h3>
    <p>Die Zwecke der Datenverarbeitung sind:</p>
    <ol>
        <li class="adsimple-113004805">
            Professionelles Hosting der Website und Absicherung des Betriebs
        </li>
        <li class="adsimple-113004805">zur Aufrechterhaltung der Betriebs- und IT-Sicherheit</li>
        <li class="adsimple-113004805">
            Anonyme Auswertung des Zugriffsverhaltens zur Verbesserung unseres Angebots und ggf. zur
            Strafverfolgung bzw. Verfolgung von Ansprüchen
        </li>
    </ol>
    <h3 class="adsimple-113004805">Welche Daten werden verarbeitet?</h3>
    <p>
        Auch während Sie unsere Website jetzt gerade besuchen, speichert unser Webserver, das ist
        der Computer auf dem diese Webseite gespeichert ist, in der Regel automatisch Daten wie
    </p>
    <ul class="adsimple-113004805">
        <li class="adsimple-113004805">
            die komplette Internetadresse (URL) der aufgerufenen Webseite
        </li>
        <li class="adsimple-113004805">Browser und Browserversion (z. B. Chrome 87)</li>
        <li class="adsimple-113004805">das verwendete Betriebssystem (z. B. Windows 10)</li>
        <li class="adsimple-113004805">
            die Adresse (URL) der zuvor besuchten Seite (Referrer URL) (z. B.
            <a
                class="adsimple-113004805"
                href="https://www.beispielquellsite.de/vondabinichgekommen/"
                target="_blank"
                rel="follow noopener"
                >https://www.beispielquellsite.de/vondabinichgekommen/</a
            >)
        </li>
        <li class="adsimple-113004805">
            den Hostnamen und die IP-Adresse des Geräts von welchem aus zugegriffen wird (z. B.
            COMPUTERNAME und 194.23.43.121)
        </li>
        <li class="adsimple-113004805">Datum und Uhrzeit</li>
        <li class="adsimple-113004805">in Dateien, den sogenannten Webserver-Logfiles</li>
    </ul>
    <h3 class="adsimple-113004805">Wie lange werden Daten gespeichert?</h3>
    <p>
        In der Regel werden die oben genannten Daten zwei Wochen gespeichert und danach automatisch
        gelöscht. Wir geben diese Daten nicht weiter, können jedoch nicht ausschließen, dass diese
        Daten beim Vorliegen von rechtswidrigem Verhalten von Behörden eingesehen werden.
    </p>
    <p>
        <strong class="adsimple-113004805">Kurz gesagt:</strong> Ihr Besuch wird durch unseren
        Provider (Firma, die unsere Website auf speziellen Computern (Servern) laufen lässt),
        protokolliert, aber wir geben Ihre Daten nicht ohne Zustimmung weiter!
    </p>
    <h3 class="adsimple-113004805">Rechtsgrundlage</h3>
    <p>
        Die Rechtmäßigkeit der Verarbeitung personenbezogener Daten im Rahmen des Webhosting ergibt
        sich aus Art. 6 Abs. 1 lit. f DSGVO (Wahrung der berechtigten Interessen), denn die Nutzung
        von professionellem Hosting bei einem Provider ist notwendig, um das Unternehmen im Internet
        sicher und nutzerfreundlich präsentieren und Angriffe und Forderungen hieraus gegebenenfalls
        verfolgen zu können.
    </p>
    <p>
        Zwischen uns und dem Hosting-Provider besteht in der Regel ein Vertrag über die
        Auftragsverarbeitung gemäß Art. 28 f. DSGVO, der die Einhaltung von Datenschutz
        gewährleistet und Datensicherheit garantiert.
    </p>
    <h2 id="webhosting-provider-extern" class="adsimple-113004805">
        Webhosting-Provider Extern Datenschutzerklärung
    </h2>
    <p>
        Nachfolgend finden Sie die Kontaktdaten unseres externen Hosting-Providers, wo Sie,
        zusätzlich zu den Informationen oben, mehr zur Datenverarbeitung erfahren können:
    </p>
    <p>
        WeCodeIt OG<br />
        Hauptstraße 65<br />
        7023 Zemendorf<br />
        Österreich
    </p>
    <p>
        Mehr über die Datenverarbeitung bei diesem Provider erfahren Sie in der
        <a
            class="adsimple-113004805"
            href="https://www.wecodeit.at/rechtliches/hosting-datenschutz"
            target="_blank"
            rel="noopener"
            >Datenschutzerklärung</a
        >.
    </p>
    <h2 id="web-analytics-einleitung" class="adsimple-113004805">Web Analytics Einleitung</h2>
    <table border="1" cellpadding="15">
        <tbody>
            <tr>
                <td>
                    <strong class="adsimple-113004805"
                        >Web Analytics Datenschutzerklärung Zusammenfassung</strong
                    >
                    <br />
                    &#x1f465; Betroffene: Besucher der Website<br />
                    &#x1f91d; Zweck: Auswertung der Besucherinformationen zur Optimierung des
                    Webangebots.<br />
                    &#x1f4d3; Verarbeitete Daten: Zugriffsstatistiken, die Daten wie Standorte der
                    Zugriffe, Gerätedaten, Zugriffsdauer und Zeitpunkt, Navigationsverhalten,
                    Klickverhalten und IP-Adressen enthalten. Mehr Details dazu finden Sie beim
                    jeweils eingesetzten Web Analytics Tool.<br />
                    &#x1f4c5; Speicherdauer: abhängig vom eingesetzten Web-Analytics-Tool<br />
                    &#x2696;&#xfe0f; Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung),
                    Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </td>
            </tr>
        </tbody>
    </table>
    <h3 class="adsimple-113004805">Was ist Web Analytics?</h3>
    <p>
        Wir verwenden auf unserer Website Software zur Auswertung des Verhaltens der
        Website-Besucher, kurz Web Analytics oder Web-Analyse genannt. Dabei werden Daten gesammelt,
        die der jeweilige Analytic-Tool-Anbieter (auch Trackingtool genannt) speichert, verwaltet
        und verarbeitet. Mit Hilfe der Daten werden Analysen über das Nutzerverhalten auf unserer
        Website erstellt und uns als Websitebetreiber zur Verfügung gestellt. Zusätzlich bieten die
        meisten Tools verschiedene Testmöglichkeiten an. So können wir etwa testen, welche Angebote
        oder Inhalte bei unseren Besuchern am besten ankommen. Dafür zeigen wir Ihnen für einen
        begrenzten Zeitabschnitt zwei verschiedene Angebote. Nach dem Test (sogenannter A/B-Test)
        wissen wir, welches Produkt bzw. welcher Inhalt unsere Websitebesucher interessanter finden.
        Für solche Testverfahren, wie auch für andere Analytics-Verfahren, können auch Userprofile
        erstellt werden und die Daten in Cookies gespeichert werden.
    </p>
    <h3 class="adsimple-113004805">Warum betreiben wir Web Analytics?</h3>
    <p>
        Mit unserer Website haben wir ein klares Ziel vor Augen: wir wollen für unsere Branche das
        beste Webangebot auf dem Markt liefern. Um dieses Ziel zu erreichen, wollen wir einerseits
        das beste und interessanteste Angebot bieten und andererseits darauf achten, dass Sie sich
        auf unserer Website rundum wohlfühlen. Mit Hilfe von Webanalyse-Tools können wir das
        Verhalten unserer Websitebesucher genauer unter die Lupe nehmen und dann entsprechend unser
        Webangebot für Sie und uns verbessern. So können wir beispielsweise erkennen wie alt unsere
        Besucher durchschnittlich sind, woher sie kommen, wann unsere Website am meisten besucht
        wird oder welche Inhalte oder Produkte besonders beliebt sind. All diese Informationen
        helfen uns die Website zu optimieren und somit bestens an Ihre Bedürfnisse, Interessen und
        Wünsche anzupassen.
    </p>
    <h3 class="adsimple-113004805">Welche Daten werden verarbeitet?</h3>
    <p>
        Welche Daten genau gespeichert werden, hängt natürlich von den verwendeten Analyse-Tools ab.
        Doch in der Regel wird zum Beispiel gespeichert, welche Inhalte Sie auf unserer Website
        ansehen, auf welche Buttons oder Links Sie klicken, wann Sie eine Seite aufrufen, welchen
        Browser sie verwenden, mit welchem Gerät (PC, Tablet, Smartphone usw.) Sie die Website
        besuchen oder welches Computersystem Sie verwenden. Wenn Sie damit einverstanden waren, dass
        auch Standortdaten erhoben werden dürfen, können auch diese durch den
        Webanalyse-Tool-Anbieter verarbeitet werden.
    </p>
    <p>
        Zudem wird auch Ihre IP-Adresse gespeichert. Gemäß der Datenschutz-Grundverordnung (DSGVO)
        sind IP-Adressen personenbezogene Daten. Ihre IP-Adresse wird allerdings in der Regel
        pseudonymisiert (also in unkenntlicher und gekürzter Form) gespeichert. Für den Zweck der
        Tests, der Webanalyse und der Weboptimierung werden grundsätzlich keine direkten Daten, wie
        etwa Ihr Name, Ihr Alter, Ihre Adresse oder Ihre E-Mail-Adresse gespeichert. All diese Daten
        werden, sofern sie erhoben werden, pseudonymisiert gespeichert. So können Sie als Person
        nicht identifiziert werden.
    </p>
    <p>
        Das folgende Beispiel zeigt schematisch die Funktionsweise von Google Analytics als Beispiel
        für client-basiertes Webtracking mit Java-Script-Code.
    </p>
    <p>
        <img
            role="img"
            src="https://www.adsimple.at/wp-content/uploads/2021/04/google-analytics-dataflow.svg"
            alt="Schematischer Datenfluss bei Google Analytics"
            width="100%" />
    </p>
    <p>
        Wie lange die jeweiligen Daten gespeichert werden, hängt immer vom Anbieter ab. Manche
        Cookies speichern Daten nur für ein paar Minuten bzw. bis Sie die Website wieder verlassen,
        andere Cookies können Daten über mehrere Jahre speichern.
    </p>
    <h3 class="adsimple-113004805">
        <span
            class="adsimple-113004805"
            data-sheets-value='{"1":2,"2":"Wo und wie lange werden Daten gespeichert?"}'
            data-sheets-userformat='{"2":769,"3":{"1":0},"11":4,"12":0}'
            >Dauer der Datenverarbeitung</span
        >
    </h3>
    <p>
        Über die Dauer der Datenverarbeitung informieren wir Sie weiter unten, sofern wir weitere
        Informationen dazu haben. Generell verarbeiten wir personenbezogene Daten nur so lange wie
        es für die Bereitstellung unserer Dienstleistungen und Produkte unbedingt notwendig ist.
        Wenn es, wie zum Beispiel im Fall von Buchhaltung, gesetzlich vorgeschrieben ist, kann diese
        Speicherdauer auch überschritten werden.
    </p>
    <h3 class="adsimple-113004805">Widerspruchsrecht</h3>
    <p>
        Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur Verwendung von
        Cookies bzw. Drittanbietern zu widerrufen. Das funktioniert entweder über unser
        Cookie-Management-Tool oder über andere Opt-Out-Funktionen. Zum Beispiel können Sie auch die
        Datenerfassung durch Cookies verhindern, indem Sie in Ihrem Browser die Cookies verwalten,
        deaktivieren oder löschen.
    </p>
    <h3 class="adsimple-113004805">Rechtsgrundlage</h3>
    <p>
        Der Einsatz von Web-Analytics setzt Ihre Einwilligung voraus, welche wir mit unserem Cookie
        Popup eingeholt haben. Diese Einwilligung stellt laut<strong class="adsimple-113004805">
            Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</strong
        >
        die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie bei der Erfassung
        durch Web-Analytics Tools vorkommen kann, dar.
    </p>
    <p>
        Zusätzlich zur Einwilligung besteht von unserer Seite ein berechtigtes Interesse daran, das
        Verhalten der Websitebesucher zu analysieren und so unser Angebot technisch und
        wirtschaftlich zu verbessern. Mit Hilfe von Web-Analytics erkennen wir Fehler der Website,
        können Attacken identifizieren und die Wirtschaftlichkeit verbessern. Die Rechtsgrundlage
        dafür ist
        <strong class="adsimple-113004805"
            >Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)</strong
        >. Wir setzen die Tools gleichwohl nur ein, soweit sie eine Einwilligung erteilt haben.
    </p>
    <p>
        Da bei Web-Analytics-Tools Cookies zum Einsatz kommen, empfehlen wir Ihnen auch das Lesen
        unserer allgemeinen Datenschutzerklärung zu Cookies. Um zu erfahren, welche Daten von Ihnen
        genau gespeichert und verarbeitet werden, sollten Sie die Datenschutzerklärungen der
        jeweiligen Tools durchlesen.
    </p>
    <p>
        Informationen zu speziellen Web-Analytics-Tools, erhalten Sie &#8211; sofern vorhanden
        &#8211; in den folgenden Abschnitten.
    </p>
    <h2 id="firebase-datenschutzerklaerung" class="adsimple-113004805">
        Firebase Datenschutzerklärung
    </h2>
    <table border="1" cellpadding="15">
        <tbody>
            <tr>
                <td>
                    <strong class="adsimple-113004805"
                        >Firebase Datenschutzerklärung Zusammenfassung</strong
                    >
                    <br />
                    &#x1f465; Betroffene: Benutzer von Firebase-Anwendungen<br />
                    &#x1f91d; Zweck: abhängig von der spezifischen Anwendung und den verwendeten
                    Firebase-Funktionen<br />
                    &#x1f4d3; Verarbeitete Daten: abhängig von der spezifischen Anwendung und den
                    verwendeten Firebase-Funktionen<br />
                    &#x1f4c5; Speicherdauer: abhängig von individuellen Konfigurationen der
                    Firebase-Anwendungen<br />
                    &#x2696;&#xfe0f; Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung),
                    Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </td>
            </tr>
        </tbody>
    </table>
    <h3 class="adsimple-113004805">Was ist Firebase?</h3>
    <p>
        Wir verwenden für unsere Geschäfte auch die App-Entwicklungsplattform Firebase.
        Dienstanbieter ist das amerikanische Unternehmen Google Inc. Für den europäischen Raum ist
        das Unternehmen Google Ireland Limited (Gordon House, Barrow Street Dublin 4, Irland) für
        alle Google-Dienste verantwortlich.
    </p>
    <p>
        Gegründet wurde das Unternehmen bereits 2011 von Andrew Lee und James Tamplin und 2014 wurde
        es von Google übernommen. In der Anfangszeit konzentrierte sich das Unternehmen in erster
        Linie auf Echtzeitdatenbank-Funktionen, die es Entwicklern ermöglichten, Daten in Echtzeit
        zwischen Usern zu synchronisieren. Durch die Übernahme von Google wurde das Angebot an Tools
        und Funktionen deutlich größer. Mittlerweile bietet Firebase beispielsweise Datenbanken,
        Hosting, Authentifizierungen, Cloud Messaging und Analysefunktionen, die bei der Entwicklung
        eigener Apps hilfreich sind. Hier finden Sie eine Übersicht zu allen Dienste, die Firebase
        anbietet:
        <a
            class="adsimple-113004805"
            href="https://firebase.google.com/terms/"
            target="_blank"
            rel="follow noopener"
            >https://firebase.google.com/terms/</a
        >
    </p>
    <h3 class="adsimple-113004805">Warum verwenden wir Firebase?</h3>
    <p>
        Mit unseren Web- oder mobilen Anwendungen wollen wir Ihnen natürlich einen nützlichen
        Service zur Verfügung stellen. Für die Entwicklung dieser Anwendungen greifen wir auf die
        Dienste und Funktionen von Firebase zurück. Die Entwicklerplattform erleichtert unsere
        Arbeit und spart Ressourcen, weil sie vor allem die Backend-Entwicklung erheblich
        vereinfacht, indem durch Dienste wie Hosting, Datenbank und Authentifizierung die nötige
        Infrastruktur bereits vorhanden ist. Zudem bietet Firebase auch leistungsstarke
        Analysefunktionen an, die uns helfen, Ihr Userverhalten besser zu verstehen. Mit Hilfe
        dieser Daten können wir unser Angebot an Ihre Bedürfnisse anpassen und folglich unser
        Service optimieren.
    </p>
    <h3 class="adsimple-113004805">Welche Daten werden durch Firebase gespeichert?</h3>
    <p>
        Welche Daten genau gespeichert werden, hängt von den jeweiligen Funktionen ab, die für die
        App verwendet werden. Für die Analyse des Nutzerverhaltens setzen Firebase-Dienste häufig
        &#8220;Instanz-IDs&#8221; ein. Dabei handelt es sich um eine eindeutige Kennung, die
        verschiedene Handlungen in der App verknüpfen kann. Laut Google werden aber dabei keine
        personenbezogene Daten verarbeitet. Durch die Analyse-Funktion werden auch diverse weitere
        Daten durch sogenannte Werbe-IDs (eindeutige Kennungen) verarbeitet. Dazu zählen zum
        Beispiel die Sitzungsdauer, Ihr verwendetes Betriebssystem, das Modell Ihres Endgeräts, Ihr
        ungefährer Standort, Handlungen in der App und Informationen zu möglichen Käufen in der App.
        Alle erhobenen Daten werden in anonymisierter Form an Google übermittelt.
    </p>
    <p>
        Für die Authentifizierung speichert Firebase auch Daten wie Username, Profilbild,
        E-Mail-Adresse und verschlüsselte Passwörter. Die Daten werden genutzt, um User zu
        authentifizieren und Ihre Identität zu verwalten. Bitte nehmen Sie zur Kenntnis, dass dabei
        auch personenbezogene Daten, wie etwa Ihre E-Mail-Adresse, verarbeitet werden kann. Wenn Sie
        über die App Push-Nachrichten erhalten, werden die Inhalte der Nachrichten, Metadaten und
        der Typ Ihres Endgeräts gespeichert.
    </p>
    <h3 class="adsimple-113004805">Wie lange und wo werden die Daten gespeichert?</h3>
    <p>
        Sowohl Speicherdauer als auch Speicherort hängen von den verwendeten Funktionen und von der
        Art der erhobenen Daten ab. Grundsätzlich speichert Firebase Daten solange, wie sie für die
        Anwendung relevant sind. Firebase ist eine Cloud-basierte Plattform und deshalb werden die
        Daten in den Rechenzentren von Google Cloud Platform (GCP) gespeichert.  Firebase Analytics
        speichert Ereignis- und andere Analysedaten grundsätzlich für 30 Tage, allerdings können sie
        auch länger gespeichert werden, wenn sie in BigQuery exportiert werden.
    </p>
    <h3 class="adsimple-113004805">
        Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
    </h3>
    <p>
        Sie haben jederzeit das Recht auf Auskunft, Berichtigung bzw. Löschung und Einschränkung der
        Verarbeitung Ihrer personenbezogenen Daten. Sie können zudem auch jederzeit die Einwilligung
        zur Verarbeitung der Daten widerrufen. Das Löschen von Daten wird in der Regel durch uns
        bzw. den Administratoren der App oder durch Sie direkt in der Benutzeroberfläche
        durchgeführt. Wie die Löschung oder die Auskunft der Daten genau erfolgt, hängt von der
        individuellen Konfiguration der App ab.
    </p>
    <h3 class="adsimple-113004805">Rechtsgrundlage</h3>
    <p>
        Firebase bzw. Google kann Daten von Ihnen auch in den USA verarbeiten. Google ist aktiver
        Teilnehmer des EU-US Data Privacy Frameworks, wodurch der korrekte und sichere Datentransfer
        personenbezogener Daten von EU-Bürgern in die USA geregelt wird. Mehr Informationen dazu
        finden Sie auf
        <a
            class="adsimple-113004805"
            href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
            target="_blank"
            rel="follow noopener">
            https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en</a
        >.
    </p>
    <p>
        Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO).
        Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind von der EU-Kommission
        bereitgestellte Mustervorlagen und sollen sicherstellen, dass Ihre Daten auch dann den
        europäischen Datenschutzstandards entsprechen, wenn diese in Drittländer (wie beispielsweise
        in die USA) überliefert und dort gespeichert werden. Durch das EU-US Data Privacy Framework
        und durch die Standardvertragsklauseln verpflichtet sich Google, bei der Verarbeitung Ihrer
        relevanten Daten, das europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in
        den USA gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf einem
        Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und die entsprechenden
        Standardvertragsklauseln u.a. hier:
        <a
            class="adsimple-113004805"
            href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
            target="_blank"
            rel="follow noopener"
            >https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de</a
        >
    </p>
    <p>
        Die Google Ads Datenverarbeitungsbedingungen (Google Ads Data Processing Terms), welche auf
        die Standardvertragsklauseln verweisen, finden Sie unter
        <a
            class="adsimple-113004805"
            href="https://business.safety.google/intl/de/adsprocessorterms/"
            target="_blank"
            rel="follow noopener"
            >https://business.safety.google/intl/de/adsprocessorterms/</a
        >.
    </p>
    <p>
        Mehr über die Daten, die durch die Verwendung von Firebase verarbeitet werden, erfahren Sie
        in der Privacy Policy auf
        <a
            class="adsimple-113004805"
            href="https://policies.google.com/privacy?hl=de"
            target="_blank"
            rel="follow noopener"
            >https://policies.google.com/privacy?hl=de</a
        >.
    </p>
    <h2 id="google-analytics-datenschutzerklaerung" class="adsimple-113004805">
        Google Analytics Datenschutzerklärung
    </h2>
    <table border="1" cellpadding="15">
        <tbody>
            <tr>
                <td>
                    <strong class="adsimple-113004805"
                        >Google Analytics Datenschutzerklärung Zusammenfassung</strong
                    >
                    <br />
                    &#x1f465; Betroffene: Besucher der Website<br />
                    &#x1f91d; Zweck: Auswertung der Besucherinformationen zur Optimierung des
                    Webangebots.<br />
                    &#x1f4d3; Verarbeitete Daten: Zugriffsstatistiken, die Daten wie Standorte der
                    Zugriffe, Gerätedaten, Zugriffsdauer und Zeitpunkt, Navigationsverhalten und
                    Klickverhalten enthalten. Mehr Details dazu finden Sie weiter unten in dieser
                    Datenschutzerklärung.<br />
                    &#x1f4c5; Speicherdauer: individuell einstellbar, standardmäßig speichert Google
                    Analytics 4 Daten für 14 Monate<br />
                    &#x2696;&#xfe0f; Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung),
                    Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </td>
            </tr>
        </tbody>
    </table>
    <h3 class="adsimple-113004805">Was ist Google Analytics?</h3>
    <p>
        Wir verwenden auf unserer Website das Analyse-Tracking Tool Google Analytics in der Version
        Google Analytics 4 (GA4) des amerikanischen Unternehmens Google Inc. Für den europäischen
        Raum ist das Unternehmen Google Ireland Limited (Gordon House, Barrow Street Dublin 4,
        Irland) für alle Google-Dienste verantwortlich. Google Analytics sammelt Daten über Ihre
        Handlungen auf unserer Website. Durch die Kombination aus verschiedenen Technologien wie
        Cookies, Geräte-IDs und Anmeldeinformationen, können Sie als User aber über verschiedene
        Geräte hinweg identifiziert werden. Dadurch können Ihre Handlungen auch
        plattformübergreifend analysiert werden.
    </p>
    <p>
        Wenn Sie beispielsweise einen Link anklicken, wird dieses Ereignis in einem Cookie
        gespeichert und an Google Analytics versandt. Mithilfe der Berichte, die wir von Google
        Analytics erhalten, können wir unsere Website und unseren Service besser an Ihre Wünsche
        anpassen. Im Folgenden gehen wir näher auf das Tracking-Tool ein und informieren Sie vor
        allem darüber, welche Daten verarbeitet werden und wie Sie das verhindern können.
    </p>
    <p>
        Google Analytics ist ein Trackingtool, das der Datenverkehrsanalyse unserer Website dient.
        Basis dieser Messungen und Analysen ist eine pseudonyme Nutzeridentifikationsnummer. Diese
        Nummer beinhaltet keine personenbezogenen Daten wie Name oder Adresse, sondern dient dazu,
        Ereignisse einem Endgerät zuzuordnen. GA4 nutzt ein ereignisbasiertes Modell, das
        detaillierte Informationen zu Userinteraktionen wie etwa Seitenaufrufe, Klicks, Scrollen,
        Conversion-Ereignisse erfasst. Zudem wurden in GA4 auch verschiedene maschinelle
        Lernfunktionen eingebaut, um das Nutzerverhalten und gewissen Trends besser zu verstehen.
        GA4 setzt mit Hilfe maschineller Lernfunktionen auf Modellierungen. Das heißt auf Grundlage
        der erhobenen Daten können auch fehlende Daten hochgerechnet werden, um damit die Analyse zu
        optimieren und auch um Prognosen geben zu können.
    </p>
    <p>
        Damit Google Analytics grundsätzlich funktioniert, wird ein Tracking-Code in den Code
        unserer Website eingebaut. Wenn Sie unsere Website besuchen, zeichnet dieser Code
        verschiedene Ereignisse auf, die Sie auf unserer Website ausführen. Mit dem
        ereignisbasierten Datenmodell von GA4 können wir als Websitebetreiber spezifische Ereignisse
        definieren und verfolgen, um Analysen von Userinteraktionen zu erhalten. Somit können neben
        allgemeinen Informationen wie Klicks oder Seitenaufrufe auch spezielle Ereignisse, die für
        unser Geschäft wichtig sind, verfolgt werden. Solche speziellen Ereignisse können zum
        Beispiel das Absenden eines Kontaktformulars oder der Kauf eines Produkts sein.
    </p>
    <p>
        Sobald Sie unsere Website verlassen, werden diese Daten an die Google-Analytics-Server
        gesendet und dort gespeichert.
    </p>
    <p>
        Google verarbeitet die Daten und wir bekommen Berichte über Ihr Userverhalten. Dabei kann es
        sich unter anderem um folgende Berichte handeln:
    </p>
    <ul class="adsimple-113004805">
        <li class="adsimple-113004805">
            Zielgruppenberichte: Über Zielgruppenberichte lernen wir unsere User besser kennen und
            wissen genauer, wer sich für unser Service interessiert.
        </li>
        <li class="adsimple-113004805">
            Anzeigeberichte: Durch Anzeigeberichte können wir unsere Onlinewerbung leichter
            analysieren und verbessern.
        </li>
        <li class="adsimple-113004805">
            Akquisitionsberichte: Akquisitionsberichte geben uns hilfreiche Informationen darüber,
            wie wir mehr Menschen für unseren Service begeistern können.
        </li>
        <li class="adsimple-113004805">
            Verhaltensberichte: Hier erfahren wir, wie Sie mit unserer Website interagieren. Wir
            können nachvollziehen welchen Weg Sie auf unserer Seite zurücklegen und welche Links Sie
            anklicken.
        </li>
        <li class="adsimple-113004805">
            Conversionsberichte: Conversion nennt man einen Vorgang, bei dem Sie aufgrund einer
            Marketing-Botschaft eine gewünschte Handlung ausführen. Zum Beispiel, wenn Sie von einem
            reinen Websitebesucher zu einem Käufer oder Newsletter-Abonnent werden. Mithilfe dieser
            Berichte erfahren wir mehr darüber, wie unsere Marketing-Maßnahmen bei Ihnen ankommen.
            So wollen wir unsere Conversionrate steigern.
        </li>
        <li class="adsimple-113004805">
            Echtzeitberichte: Hier erfahren wir immer sofort, was gerade auf unserer Website
            passiert. Zum Beispiel sehen wir wie viele User gerade diesen Text lesen.
        </li>
    </ul>
    <p>
        Neben den oben genannten Analyseberichten bietet Google Analytics 4 unter anderem auch
        folgende Funktionen an:
    </p>
    <ul class="adsimple-113004805">
        <li class="adsimple-113004805">
            Ereignisbasiertes Datenmodell: Dieses Modell erfasst ganz spezifische Ereignisse, die
            auf unserer Website stattfinden können. Zum Beispiel das Abspielen eines Videos, der
            Kauf eines Produkts oder das Anmelden zu unserem Newsletter.
        </li>
        <li class="adsimple-113004805">
            Erweiterte Analysefunktionen: Mit diesen Funktionen können wir Ihr Verhalten auf unserer
            Website oder gewisse allgemeine Trends noch besser verstehen. So können wir etwa
            Usergruppen segmentieren, Vergleichsanalysen von Zielgruppen machen oder Ihren Weg bzw.
            Pfad auf unserer Website nachvollziehen.
        </li>
        <li class="adsimple-113004805">
            Vorhersagemodellierung: Auf Grundlage erhobener Daten können durch maschinelles Lernen
            fehlende Daten hochgerechnet werden, die zukünftige Ereignisse und Trends vorhersagen.
            Das kann uns helfen, bessere Marketingstrategien zu entwickeln.
        </li>
        <li class="adsimple-113004805">
            Cross-Plattform-Analyse: Die Erfassung und Analyse von Daten sind sowohl von Websites
            als auch von Apps möglich. Das bietet uns die Möglichkeit, das Userverhalten
            plattformübergreifend zu analysieren, sofern Sie natürlich der Datenverarbeitung
            eingewilligt haben.
        </li>
    </ul>
    <h3 class="adsimple-113004805">Warum verwenden wir Google Analytics auf unserer Website?</h3>
    <p>
        Unser Ziel mit dieser Website ist klar: Wir wollen Ihnen den bestmöglichen Service bieten.
        Die Statistiken und Daten von Google Analytics helfen uns dieses Ziel zu erreichen.
    </p>
    <p>
        Die statistisch ausgewerteten Daten zeigen uns ein klares Bild von den Stärken und Schwächen
        unserer Website. Einerseits können wir unsere Seite so optimieren, dass sie von
        interessierten Menschen auf Google leichter gefunden wird. Andererseits helfen uns die
        Daten, Sie als Besucher besser zu verstehen. Wir wissen somit sehr genau, was wir an unserer
        Website verbessern müssen, um Ihnen das bestmögliche Service zu bieten. Die Daten dienen uns
        auch, unsere Werbe- und Marketing-Maßnahmen individueller und kostengünstiger durchzuführen.
        Schließlich macht es nur Sinn, unsere Produkte und Dienstleistungen Menschen zu zeigen, die
        sich dafür interessieren.
    </p>
    <h3 class="adsimple-113004805">Welche Daten werden von Google Analytics gespeichert?</h3>
    <p>
        Google Analytics erstellt mithilfe eines Tracking-Codes eine zufällige, eindeutige ID, die
        mit Ihrem Browser-Cookie verbunden ist. So erkennt Sie Google Analytics als neuen User und
        Ihnen wird eine User-ID zugeordnet. Wenn Sie das nächste Mal unsere Seite besuchen, werden
        Sie als „wiederkehrender“ User erkannt. Alle gesammelten Daten werden gemeinsam mit dieser
        User-ID gespeichert. So ist es erst möglich pseudonyme Userprofile auszuwerten.
    </p>
    <p>
        Um mit Google Analytics unsere Website analysieren zu können, muss eine Property-ID in den
        Tracking-Code eingefügt werden. Die Daten werden dann in der entsprechenden Property
        gespeichert. Für jede neu angelegte Property ist die Google Analytics 4-Property
        standardmäßig. Je nach verwendeter Property werden Daten unterschiedlich lange gespeichert.
    </p>
    <p>
        Durch Kennzeichnungen wie Cookies, App-Instanz-IDs, User-IDs oder etwa benutzerdefinierte
        Ereignisparameter werden Ihre Interaktionen, sofern Sie eingewilligt haben,
        plattformübergreifend gemessen. Interaktionen sind alle Arten von Handlungen, die Sie auf
        unserer Website ausführen. Wenn Sie auch andere Google-Systeme (wie z.B. ein Google-Konto)
        nützen, können über Google Analytics generierte Daten mit Drittanbieter-Cookies verknüpft
        werden. Google gibt keine Google Analytics-Daten weiter, außer wir als Websitebetreiber
        genehmigen das. Zu Ausnahmen kann es kommen, wenn es gesetzlich erforderlich ist.
    </p>
    <p>
        Laut Google werden in Google Analytics 4 keine IP-Adressen protokolliert oder gespeichert.
        Google nutzt die IP-Adressdaten allerdings für die Ableitung von Standortdaten und löscht
        sie unmittelbar danach. Alle IP-Adressen, die von Usern in der EU erhoben werden, werden
        also gelöscht, bevor die Daten in einem Rechenzentrum oder auf einem Server gespeichert
        werden.
    </p>
    <p>
        Da bei Google Analytics 4 der Fokus auf ereignisbasierten Daten liegt, verwendet das Tool im
        Vergleich zu früheren Versionen (wie Google Universal Analytics) deutlich weniger Cookies.
        Dennoch gibt es einige spezifische Cookies, die von GA4 verwendet werden. Dazu zählen zum
        Beispiel:
    </p>
    <p>
        <strong class="adsimple-113004805">Name:</strong> _ga<br />
        <strong class="adsimple-113004805">Wert: </strong>2.1326744211.152113004805-5<br />
        <strong class="adsimple-113004805">Verwendungszweck:</strong> Standardmäßig verwendet
        analytics.js das Cookie _ga, um die User-ID zu speichern. Grundsätzlich dient es zur
        Unterscheidung der Webseitenbesucher.<br />
        <strong class="adsimple-113004805">Ablaufdatum:</strong> nach 2 Jahren
    </p>
    <p>
        <strong class="adsimple-113004805">Name:</strong> _gid<br />
        <strong class="adsimple-113004805">Wert: </strong>2.1687193234.152113004805-1<br />
        <strong class="adsimple-113004805">Verwendungszweck:</strong> Das Cookie dient auch zur
        Unterscheidung der Webseitenbesucher<br />
        <strong class="adsimple-113004805">Ablaufdatum:</strong> nach 24 Stunden
    </p>
    <p>
        <strong class="adsimple-113004805">Name:</strong> _gat_gtag_UA_&lt;property-id&gt;<br />
        <strong class="adsimple-113004805">Wert:</strong> 1<br />
        <strong class="adsimple-113004805">Verwendungszweck:</strong> Wird zum Senken der
        Anforderungsrate verwendet. Wenn Google Analytics über den Google Tag Manager bereitgestellt
        wird, erhält dieser Cookie den Namen _dc_gtm_ &lt;property-id&gt;.<br />
        <strong class="adsimple-113004805">Ablaufdatum: </strong>nach 1 Minute
    </p>
    <p>
        <strong class="adsimple-113004805">Anmerkung:</strong> Diese Aufzählung kann keinen Anspruch
        auf Vollständigkeit erheben, da Google die Wahl ihrer Cookies immer wieder auch verändert.
        Ziel von GA4 ist es auch, den Datenschutz zu verbessern. Daher bietet das Tool einige
        Möglichkeiten zur Kontrolle der Datenerfassung. So können wir beispielsweise die
        Speicherdauer selbst festlegen und auch die Datenerfassung steuern.
    </p>
    <p>
        Hier zeigen wir Ihnen einen Überblick über die wichtigsten Arten von Daten, die mit Google
        Analytics erhoben werden:
    </p>
    <p>
        <strong class="adsimple-113004805">Heatmaps:</strong> Google legt sogenannte Heatmaps an.
        Über Heatmaps sieht man genau jene Bereiche, die Sie anklicken. So bekommen wir
        Informationen, wo Sie auf unserer Seite „unterwegs“ sind.
    </p>
    <p>
        <strong class="adsimple-113004805">Sitzungsdauer:</strong> Als Sitzungsdauer bezeichnet
        Google die Zeit, die Sie auf unserer Seite verbringen, ohne die Seite zu verlassen. Wenn Sie
        20 Minuten inaktiv waren, endet die Sitzung automatisch.
    </p>
    <p>
        <strong class="adsimple-113004805">Absprungrate</strong> (engl. Bouncerate): Von einem
        Absprung ist die Rede, wenn Sie auf unserer Website nur eine Seite ansehen und dann unsere
        Website wieder verlassen.
    </p>
    <p>
        <strong class="adsimple-113004805">Kontoerstellung:</strong> Wenn Sie auf unserer Website
        ein Konto erstellen bzw. eine Bestellung machen, erhebt Google Analytics diese Daten.
    </p>
    <p>
        <strong class="adsimple-113004805">Standort:</strong> IP-Adressen werden in Google Analytics
        nicht protokolliert oder gespeichert. Allerdings werden kurz vor der Löschung der IP-Adresse
        Ableitungen für Standortdaten genutzt.
    </p>
    <p>
        <strong class="adsimple-113004805">Technische Informationen:</strong> Zu den technischen
        Informationen zählen unter anderem Ihr Browsertyp, Ihr Internetanbieter oder Ihre
        Bildschirmauflösung.
    </p>
    <p>
        <strong class="adsimple-113004805">Herkunftsquelle:</strong> Google Analytics
        beziehungsweise uns interessiert natürlich auch über welche Website oder welche Werbung Sie
        auf unsere Seite gekommen sind.
    </p>
    <p>
        Weitere Daten sind Kontaktdaten, etwaige Bewertungen, das Abspielen von Medien (z. B., wenn
        Sie ein Video über unsere Seite abspielen), das Teilen von Inhalten über Social Media oder
        das Hinzufügen zu Ihren Favoriten. Die Aufzählung hat keinen Vollständigkeitsanspruch und
        dient nur zu einer allgemeinen Orientierung der Datenspeicherung durch Google Analytics.
    </p>
    <h3 class="adsimple-113004805">Wie lange und wo werden die Daten gespeichert?</h3>
    <p>
        Google hat ihre Server auf der ganzen Welt verteilt. Hier können Sie genau nachlesen, wo
        sich die Google-Rechenzentren befinden:
        <a
            class="adsimple-113004805"
            href="https://www.google.com/about/datacenters/locations/?hl=de"
            >https://www.google.com/about/datacenters/locations/?hl=de</a
        >
    </p>
    <p>
        Ihre Daten werden auf verschiedenen physischen Datenträgern verteilt. Das hat den Vorteil,
        dass die Daten schneller abrufbar sind und vor Manipulation besser geschützt sind. In jedem
        Google-Rechenzentrum gibt es entsprechende Notfallprogramme für Ihre Daten. Wenn
        beispielsweise die Hardware bei Google ausfällt oder Naturkatastrophen Server lahmlegen,
        bleibt das Risiko einer Dienstunterbrechung bei Google dennoch gering.
    </p>
    <p>
        Die Aufbewahrungsdauer der Daten hängt von den verwendeten Properties ab. Die Speicherdauer
        wird stets für jede einzelne Property eigens festgelegt. Google Analytics bietet uns zur
        Kontrolle der Speicherdauer vier Optionen an:
    </p>
    <ul class="adsimple-113004805">
        <li class="adsimple-113004805">2 Monate: das ist die kürzeste Speicherdauer.</li>
        <li class="adsimple-113004805">
            14 Monate: standardmäßig bleiben die Daten bei GA4 für 14 Monate gespeichert.
        </li>
        <li class="adsimple-113004805">
            26 Monate: man kann die Daten auch 26 Monate lang speichern.
        </li>
        <li class="adsimple-113004805">Daten werden erst gelöscht, wenn wir sie manuell löschen</li>
    </ul>
    <p>
        Zusätzlich gibt es auch die Option, dass Daten erst dann gelöscht werden, wenn Sie innerhalb
        des von uns gewählten Zeitraums nicht mehr unsere Website besuchen. In diesem Fall wird die
        Aufbewahrungsdauer jedes Mal zurückgesetzt, wenn Sie unsere Website innerhalb des
        festgelegten Zeitraums wieder besuchen.
    </p>
    <p>
        Wenn der festgelegte Zeitraum abgelaufen ist, werden einmal im Monat die Daten gelöscht.
        Diese Aufbewahrungsdauer gilt für Ihre Daten, die mit Cookies, Usererkennung und Werbe-IDs
        (z.B. Cookies der DoubleClick-Domain) verknüpft sind. Berichtergebnisse basieren auf
        aggregierten Daten und werden unabhängig von Nutzerdaten gespeichert. Aggregierte Daten sind
        eine Zusammenschmelzung von Einzeldaten zu einer größeren Einheit.
    </p>
    <h3 class="adsimple-113004805">
        Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
    </h3>
    <p>
        Nach dem Datenschutzrecht der Europäischen Union haben Sie das Recht, Auskunft über Ihre
        Daten zu erhalten, sie zu aktualisieren, zu löschen oder einzuschränken. Mithilfe des
        Browser-Add-ons zur Deaktivierung von Google Analytics-JavaScript (analytics.js, gtag.js)
        verhindern Sie, dass Google Analytics 4 Ihre Daten verwendet. Das Browser-Add-on können Sie
        unter
        <a class="adsimple-113004805" href="https://tools.google.com/dlpage/gaoptout?hl=de"
            >https://tools.google.com/dlpage/gaoptout?hl=de</a
        >
        runterladen und installieren. Beachten Sie bitte, dass durch dieses Add-on nur die
        Datenerhebung durch Google Analytics deaktiviert wird.
    </p>
    <p>
        Falls Sie grundsätzlich Cookies deaktivieren, löschen oder verwalten wollen, finden Sie
        unter dem Abschnitt „Cookies“ die entsprechenden Links zu den jeweiligen Anleitungen der
        bekanntesten Browser.
    </p>
    <h3 class="adsimple-113004805">Rechtsgrundlage</h3>
    <p>
        Der Einsatz von Google Analytics setzt Ihre Einwilligung voraus, welche wir mit unserem
        Cookie Popup eingeholt haben. Diese Einwilligung stellt laut<strong
            class="adsimple-113004805">
            Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</strong
        >
        die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie bei der Erfassung
        durch Web-Analytics Tools vorkommen kann, dar.
    </p>
    <p>
        Zusätzlich zur Einwilligung besteht von unserer Seite ein berechtigtes Interesse daran, das
        Verhalten der Websitebesucher zu analysieren und so unser Angebot technisch und
        wirtschaftlich zu verbessern. Mit Hilfe von Google Analytics erkennen wir Fehler der
        Website, können Attacken identifizieren und die Wirtschaftlichkeit verbessern. Die
        Rechtsgrundlage dafür ist
        <strong class="adsimple-113004805"
            >Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)</strong
        >. Wir setzen Google Analytics gleichwohl nur ein, soweit Sie eine Einwilligung erteilt
        haben.
    </p>
    <p>
        Google verarbeitet Daten von Ihnen u.a. auch in den USA. Google ist aktiver Teilnehmer des
        EU-US Data Privacy Frameworks, wodurch der korrekte und sichere Datentransfer
        personenbezogener Daten von EU-Bürgern in die USA geregelt wird. Mehr Informationen dazu
        finden Sie auf
        <a
            class="adsimple-113004805"
            href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
            target="_blank"
            rel="follow noopener">
            https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en</a
        >.
    </p>
    <p>
        Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO).
        Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind von der EU-Kommission
        bereitgestellte Mustervorlagen und sollen sicherstellen, dass Ihre Daten auch dann den
        europäischen Datenschutzstandards entsprechen, wenn diese in Drittländer (wie beispielsweise
        in die USA) überliefert und dort gespeichert werden. Durch das EU-US Data Privacy Framework
        und durch die Standardvertragsklauseln verpflichtet sich Google, bei der Verarbeitung Ihrer
        relevanten Daten, das europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in
        den USA gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf einem
        Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und die entsprechenden
        Standardvertragsklauseln u.a. hier:
        <a
            class="adsimple-113004805"
            href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
            target="_blank"
            rel="follow noopener"
            >https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de</a
        >
    </p>
    <p>
        Die Google Ads Datenverarbeitungsbedingungen (Google Ads Data Processing Terms), welche auf
        die Standardvertragsklauseln verweisen, finden Sie unter
        <a
            class="adsimple-113004805"
            href="https://business.safety.google/intl/de/adsprocessorterms/"
            target="_blank"
            rel="follow noopener"
            >https://business.safety.google/intl/de/adsprocessorterms/</a
        >.
    </p>
    <p>
        Wir hoffen, wir konnten Ihnen die wichtigsten Informationen rund um die Datenverarbeitung
        von Google Analytics näherbringen. Wenn Sie mehr über den Tracking-Dienst erfahren wollen,
        empfehlen wir diese beiden Links:
        <a
            class="adsimple-113004805"
            href="https://marketingplatform.google.com/about/analytics/terms/de/"
            target="_blank"
            rel="follow noopener"
            >https://marketingplatform.google.com/about/analytics/terms/de/</a
        >
        und
        <a
            class="adsimple-113004805"
            href="https://support.google.com/analytics/answer/6004245?hl=de"
            target="_blank"
            rel="follow noopener"
            >https://support.google.com/analytics/answer/6004245?hl=de</a
        >.
    </p>
    <p>
        Wenn Sie mehr über die Datenverarbeitung erfahren wollen, nutzen Sie die
        Google-Datenschutzerklärung auf
        <a
            class="adsimple-113004805"
            href="https://policies.google.com/privacy?hl=de&amp;tid=113004805"
            target="_blank"
            rel="follow noopener"
            >https://policies.google.com/privacy?hl=de</a
        >.
    </p>
    <h2 id="auftragsverarbeitungsvertrag-avv-google-analytics" class="adsimple-113004805">
        Auftragsverarbeitungsvertrag (AVV) Google Analytics
    </h2>
    <p>
        Wir haben im Sinne des Artikels 28 der Datenschutz-Grundverordnung (DSGVO) mit Google einen
        Auftragsverarbeitungsvertrag (AVV) abgeschlossen. Was ein AVV genau ist und vor allem was in
        einem AVV enthalten sein muss, können Sie in unserem allgemeinen Abschnitt
        „Auftragsverarbeitungsvertrag (AVV)“ nachlesen.
    </p>
    <p>
        Dieser Vertrag ist gesetzlich vorgeschrieben, weil Google in unserem Auftrag
        personenbezogene Daten verarbeitet. Darin wird geklärt, dass Google Daten, die sie von uns
        erhalten, nur nach unserer Weisung verarbeiten darf und die DSGVO einhalten muss. Den Link
        zu den Auftragsdatenverarbeitungsbedingungen finden Sie unter
        <a
            class="adsimple-113004805"
            href="https://business.safety.google/intl/de/adsprocessorterms/"
            target="_blank"
            rel="follow noopener"
            >https://business.safety.google/intl/de/adsprocessorterms/</a
        >
    </p>
    <h2 id="google-analytics-ip-anonymisierung" class="adsimple-113004805">
        Google Analytics IP-Anonymisierung
    </h2>
    <p>
        Wir haben auf dieser Webseite die IP-Adressen-Anonymisierung von Google Analytics
        implementiert. Diese Funktion wurde von Google entwickelt, damit diese Webseite die
        geltenden Datenschutzbestimmungen und Empfehlungen der lokalen Datenschutzbehörden einhalten
        kann, wenn diese eine Speicherung der vollständigen IP-Adresse untersagen. Die
        Anonymisierung bzw. Maskierung der IP findet statt, sobald die IP-Adressen im Google
        Analytics-Datenerfassungsnetzwerk eintreffen und bevor eine Speicherung oder Verarbeitung
        der Daten stattfindet.
    </p>
    <p>
        Mehr Informationen zur IP-Anonymisierung finden Sie auf <a
            class="adsimple-113004805"
            href="https://support.google.com/analytics/answer/2763052?hl=de"
            target="_blank"
            rel="noopener"
            >https://support.google.com/analytics/answer/2763052?hl=de</a
        >.
    </p>
    <h2 id="google-analytics-ohne-cookies" class="adsimple-113004805">
        Google Analytics ohne Cookies
    </h2>
    <p>
        Wir nutzen auf unserer Website zwar Google Analytics (kurz GA), allerdings ohne Cookies in
        Ihrem Browser zu setzen. Was Cookies sind, haben wir bereits weiter oben erklärt,
        hoffentlich sind die Ausführungen noch im Gedächtnis. Nur kurz und konkret auf GA bezogen:
        Durch Cookies werden für GA hilfreiche Daten in Ihrem Browser auf Ihrem Gerät gespeichert.
        Durch den Entfall der Nutzung von Cookies werden gerade keine personenbezogenen Daten in
        solchen Cookies gespeichert, die ein Nutzerprofil begründen werden. Google Analytics kann
        zwar diverse Messungen und Webanalysen durchführen, jedoch werden die dafür erhobenen Daten
        lediglich auf den Google-Servern gespeichert und Ihre Privatsphäre wird deutlich stärker
        respektiert und geschützt.
    </p>
    <h2 id="cookie-consent-management-platform-einleitung" class="adsimple-113004805">
        Cookie Consent Management Platform Einleitung
    </h2>
    <table border="1" cellpadding="15">
        <tbody>
            <tr>
                <td>
                    <strong class="adsimple-113004805"
                        >Cookie Consent Management Platform Zusammenfassung</strong
                    >
                    <br />
                    &#x1f465; Betroffene: Website Besucher<br />
                    &#x1f91d; Zweck: Einholung und Verwaltung der Zustimmung zu bestimmten Cookies
                    und somit dem Einsatz bestimmter Tools<br />
                    &#x1f4d3; Verarbeitete Daten: Daten zur Verwaltung der eingestellten
                    Cookie-Einstellungen wie IP-Adresse, Zeitpunkt der Zustimmung, Art der
                    Zustimmung, einzelne Zustimmungen. Mehr Details dazu finden Sie beim jeweils
                    eingesetzten Tool.<br />
                    &#x1f4c5; Speicherdauer: Hängt vom eingesetzten Tool ab, man muss sich auf
                    Zeiträume von mehreren Jahren einstellen<br />
                    &#x2696;&#xfe0f; Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung),
                    Art. 6 Abs. 1 lit.f DSGVO (berechtigte Interessen)
                </td>
            </tr>
        </tbody>
    </table>
    <h3 class="adsimple-113004805">Was ist eine Cookie Consent Manangement Platform?</h3>
    <p>
        Wir verwenden auf unserer Website eine Consent Management Platform (CMP) Software, die uns
        und Ihnen den korrekten und sicheren Umgang mit verwendeten Skripten und Cookies
        erleichtert. Die Software erstellt automatisch ein Cookie-Popup, scannt und kontrolliert
        alle Skripts und Cookies, bietet eine datenschutzrechtlich notwendige Cookie-Einwilligung
        für Sie und hilft uns und Ihnen den Überblick über alle Cookies zu behalten. Bei den meisten
        Cookie Consent Management Tools werden alle vorhandenen Cookies identifiziert und
        kategorisiert. Sie als Websitebesucher entscheiden dann selbst, ob und welche Skripte und
        Cookies Sie zulassen oder nicht zulassen. Die folgende Grafik stellt die Beziehung zwischen
        Browser, Webserver und CMP dar.
    </p>
    <p>
        <img
            role="img"
            src="https://www.adsimple.at/wp-content/uploads/2021/03/consent-management-platform-overview.svg"
            alt="Consent Management Platform Überblick"
            width="100%" />
    </p>
    <h3 class="adsimple-113004805">Warum verwenden wir ein Cookie-Management-Tool?</h3>
    <p>
        Unser Ziel ist es, Ihnen im Bereich Datenschutz die bestmögliche Transparenz zu bieten.
        Zudem sind wir dazu auch rechtlich verpflichtet. Wir wollen Sie über alle Tools und alle
        Cookies, die Daten von Ihnen speichern und verarbeiten können, so gut wie möglich aufklären.
        Es ist auch Ihr Recht, selbst zu entscheiden, welche Cookies Sie akzeptieren und welche
        nicht. Um Ihnen dieses Recht einzuräumen, müssen wir zuerst genau wissen, welche Cookies
        überhaupt auf unserer Website gelandet sind. Dank eines Cookie-Management-Tools, welches die
        Website regelmäßig nach allen vorhandenen Cookies scannt, wissen wir über alle Cookies
        Bescheid und können Ihnen DSGVO-konform Auskunft darüber geben. Über das Einwilligungssystem
        können Sie dann Cookies akzeptieren oder ablehnen.
    </p>
    <h3 class="adsimple-113004805">Welche Daten werden verarbeitet?</h3>
    <p>
        Im Rahmen unseres Cookie-Management-Tools können Sie jedes einzelnen Cookies selbst
        verwalten und haben die vollständige Kontrolle über die Speicherung und Verarbeitung Ihrer
        Daten. Die Erklärung Ihrer Einwilligung wird gespeichert, damit wir Sie nicht bei jedem
        neuen Besuch unserer Website abfragen müssen und wir Ihre Einwilligung, wenn gesetzlich
        nötig, auch nachweisen können. Gespeichert wird dies entweder in einem Opt-in-Cookie oder
        auf einem Server. Je nach Anbieter des Cookie-Management-Tools variiert Speicherdauer Ihrer
        Cookie-Einwilligung. Meist werden diese Daten (etwa pseudonyme User-ID,
        Einwilligungs-Zeitpunkt, Detailangaben zu den Cookie-Kategorien oder Tools, Browser,
        Gerätinformationen) bis zu zwei Jahren gespeichert.
    </p>
    <h3 class="adsimple-113004805">Dauer der Datenverarbeitung</h3>
    <p>
        Über die Dauer der Datenverarbeitung informieren wir Sie weiter unten, sofern wir weitere
        Informationen dazu haben. Generell verarbeiten wir personenbezogene Daten nur so lange wie
        es für die Bereitstellung unserer Dienstleistungen und Produkte unbedingt notwendig ist.
        Daten, die in Cookies gespeichert werden, werden unterschiedlich lange gespeichert. Manche
        Cookies werden bereits nach dem Verlassen der Website wieder gelöscht, andere können über
        einige Jahre in Ihrem Browser gespeichert sein. Die genaue Dauer der Datenverarbeitung hängt
        vom verwendeten Tool ab, meistens sollten Sie sich auf eine Speicherdauer von mehreren
        Jahren einstellen. In den jeweiligen Datenschutzerklärungen der einzelnen Anbieter erhalten
        Sie in der Regel genaue Informationen über die Dauer der Datenverarbeitung.
    </p>
    <h3 class="adsimple-113004805">Widerspruchsrecht</h3>
    <p>
        Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur Verwendung von
        Cookies zu widerrufen. Das funktioniert entweder über unser Cookie-Management-Tool oder über
        andere Opt-Out-Funktionen. Zum Beispiel können Sie auch die Datenerfassung durch Cookies
        verhindern, indem Sie in Ihrem Browser die Cookies verwalten, deaktivieren oder löschen.
    </p>
    <p>
        Informationen zu speziellen Cookie-Management-Tools, erfahren Sie &#8211; sofern vorhanden
        &#8211; in den folgenden Abschnitten.
    </p>
    <h3 class="adsimple-113004805">Rechtsgrundlage</h3>
    <p>
        Wenn Sie Cookies zustimmen, werden über diese Cookies personenbezogene Daten von Ihnen
        verarbeitet und gespeichert. Falls wir durch Ihre
        <strong class="adsimple-113004805">Einwilligung</strong> (Artikel 6 Abs. 1 lit. a DSGVO)
        Cookies verwenden dürfen, ist diese Einwilligung auch gleichzeitig die Rechtsgrundlage für
        die Verwendung von Cookies bzw. die Verarbeitung Ihrer Daten. Um die Einwilligung zu Cookies
        verwalten zu können und Ihnen die Einwilligung ermöglichen zu können, kommt eine
        Cookie-Consent-Management-Platform-Software zum Einsatz. Der Einsatz dieser Software
        ermöglicht uns, die Website auf effiziente Weise rechtskonform zu betreiben, was ein
        <strong class="adsimple-113004805">berechtigtes Interesse</strong> (Artikel 6 Abs. 1 lit. f
        DSGVO) darstellt.
    </p>
    <h2 id="adsimple-consent-manager-datenschutzerklaerung" class="adsimple-113004805">
        AdSimple Consent Manager Datenschutzerklärung
    </h2>
    <table border="1" cellpadding="15">
        <tbody>
            <tr>
                <td>
                    <strong class="adsimple-113004805"
                        >AdSimple Consent Manager Datenschutzerklärung Zusammenfassung</strong
                    >
                    <br />
                    &#x1f465; Betroffene: Website Besucher<br />
                    &#x1f91d; Zweck: Einholung der Zustimmung zu bestimmten Cookies und somit dem
                    Einsatz bestimmter Tools<br />
                    &#x1f4d3; Verarbeitete Daten: Daten zur Verwaltung der eingestellten
                    Cookie-Einstellungen wie IP-Adresse, Zeitpunkt der Zustimmung, Art der
                    Zustimmung, einzelne Zustimmungen. Mehr Details dazu finden Sie weiter unter in
                    dieser Datenschutzerklärung<br />
                    &#x1f4c5; Speicherdauer: das verwendete Cookie läuft nach einem Jahr ab<br />
                    &#x2696;&#xfe0f; Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung),
                    Art. 6 Abs. 1 lit.f DSGVO (berechtigte Interessen)
                </td>
            </tr>
        </tbody>
    </table>
    <h3 class="adsimple-113004805">Was ist der AdSimple Consent Manager?</h3>
    <p>
        Wir verwenden auf unserer Website den AdSimple Consent Manager des Softwareentwicklungs- und
        Online-Marketing Unternehmens AdSimple GmbH, Fabriksgasse 20, 2230 Gänserndorf. Der AdSimple
        Consent Manager bietet uns unter anderem die Möglichkeit, Ihnen einen umfangreichen und
        datenschutzkonformen Cookie-Hinweis zu liefern, damit Sie selbst entscheiden können, welche
        Cookies Sie zulassen und welche nicht. Durch die Verwendung dieser Software werden Daten von
        Ihnen an AdSimple gesendet und gespeichert. In dieser Datenschutzerklärung informieren wir
        Sie, warum wir den AdSimple Consent Manager verwenden, welche Daten übertragen und
        gespeichert werden und wie Sie diese Datenübertragung verhindern können.
    </p>
    <p>
        Der AdSimple Consent Manager ist eine Software, die unsere Website scannt und alle
        vorhandenen Cookies identifiziert und kategorisiert. Zudem werden Sie als Websitebesucher
        über ein Cookie Hinweis Script über die Verwendung von Cookies informiert und entscheiden
        selbst welche Cookies Sie zulassen und welche nicht.
    </p>
    <h3 class="adsimple-113004805">
        Warum verwenden wir den AdSimple Consent Manager auf unserer Website?
    </h3>
    <p>
        Wir wollen Ihnen maximale Transparenz im Bereich Datenschutz bieten. Um das zu
        gewährleisten, müssen wir zuerst genau wissen, welche Cookies im Laufe der Zeit auf unserer
        Website gelandet sind. Dadurch, dass der Consent Manager von AdSimple regelmäßig unsere
        Website scannt und alle Cookies ausfindig macht, haben wir die volle Kontrolle über diese
        Cookies und können so DSGVO-konform handeln. Wir können Sie dadurch über die Nutzung der
        Cookies auf unserer Website genau informieren. Weiters bekommen Sie stets einen aktuellen
        und datenschutzkonformen Cookie-Hinweis und entscheiden per Checkbox-System selbst, welche
        Cookies Sie akzeptieren bzw. blockieren.
    </p>
    <h3 class="adsimple-113004805">
        Welche Daten werden von dem AdSimple Consent Manager gespeichert?
    </h3>
    <p>
        Wenn Sie Cookies auf unserer Website zustimmen, wird folgendes Cookie von dem AdSimple
        Consent Manager gesetzt:
    </p>
    <p>
        <strong class="adsimple-113004805">Name:</strong> acm_status<br />
        <strong class="adsimple-113004805">Wert:</strong
        >&#123;&#8220;:true,&#8221;statistik&#8221;:true,&#8221;marketing&#8221;:true,&#8221;socialmedia&#8221;:true,&#8221;einstellungen&#8221;:true&#125;
        <br />
        <strong class="adsimple-113004805">Verwendungszweck:</strong> In diesem Cookie wird Ihr
        Zustimmungsstatus, gespeichert. Dadurch kann unsere Website auch bei zukünftigen Besuchen
        den aktuellen Status lesen und befolgen.<br />
        <strong class="adsimple-113004805">Ablaufdatum:</strong> nach einem Jahr
    </p>
    <h3 class="adsimple-113004805">Wie lange und wo werden die Daten gespeichert?</h3>
    <p>
        Alle Daten, die durch den AdSimple Consent Manager erhoben werden, werden ausschließlich
        innerhalb der Europäischen Union übertragen und gespeichert. Die erhobenen Daten werden auf
        den Servern von AdSimple bei der Hetzner GmbH in Deutschland gespeichert. Zugriff auf diese
        Daten hat ausschließlich die AdSimple GmbH und die Hetzner GmbH.
    </p>
    <h3 class="adsimple-113004805">
        Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
    </h3>
    <p>
        Sie haben jederzeit das Recht auf Ihre personenbezogenen Daten zuzugreifen und sie auch zu
        löschen. Die Datenerfassung und Speicherung können Sie beispielsweise verhindern, indem Sie
        über das Cookie-Hinweis-Script die Verwendung von Cookies ablehnen. Eine weitere Möglichkeit
        die Datenverarbeitung zu unterbinden bzw. nach Ihren Wünschen zu verwalten, bietet Ihr
        Browser. Je nach Browser funktioniert die Cookie-Verwaltung etwas anders. Unter dem
        Abschnitt „Cookies“ finden Sie die entsprechenden Links zu den jeweiligen Anleitungen der
        bekanntesten Browser.
    </p>
    <h3 class="adsimple-113004805">Rechtsgrundlage</h3>
    <p>
        Wenn Sie Cookies zustimmen, werden über diese Cookies personenbezogene Daten von Ihnen
        verarbeitet und gespeichert. Falls wir durch Ihre
        <strong class="adsimple-113004805">Einwilligung</strong> (Artikel 6 Abs. 1 lit. a DSGVO)
        Cookies verwenden dürfen, ist diese Einwilligung auch gleichzeitig die Rechtsgrundlage für
        die Verwendung von Cookies bzw. die Verarbeitung Ihrer Daten. Um die Einwilligung zu Cookies
        verwalten zu können und Ihnen die Einwilligung ermöglichen zu können, kommt der AdSimple
        Consent Manager zum Einsatz. Der Einsatz dieser Software ermöglicht uns, die Website auf
        effiziente Weise rechtskonform zu betreiben, was ein
        <strong class="adsimple-113004805">berechtigtes Interesse</strong> (Artikel 6 Abs. 1 lit. f
        DSGVO) darstellt.
    </p>
    <p>
        Wir hoffen, wir haben Ihnen einen guten Überblick über den Datenverkehr und die
        Datenverarbeitung durch den AdSimple Consent Manager geliefert. Wenn Sie mehr über dieses
        Tool erfahren wollen, empfehlen wir Ihnen die Beschreibungsseite auf
        <a
            class="adsimple-113004805"
            href="https://www.adsimple.at/consent-manager/?tid=113004805"
            target="_blank"
            rel="follow noopener"
            >https://www.adsimple.at/consent-manager/</a
        >.
    </p>
    <h2 id="security-anti-spam" class="adsimple-113004805">Security &amp; Anti-Spam</h2>
    <table border="1" cellpadding="15">
        <tbody>
            <tr>
                <td>
                    <strong class="adsimple-113004805"
                        >Security &amp; Anti-Spam Datenschutzerklärung Zusammenfassung</strong
                    >
                    <br />
                    &#x1f465; Betroffene: Besucher der Website<br />
                    &#x1f91d; Zweck: Cybersicherheit<br />
                    &#x1f4d3; Verarbeitete Daten: Daten wie etwa Ihre IP-Adresse, Name oder
                    technische Daten wie etwa Browserversion<br />
                    Mehr Details dazu finden Sie weiter unten und den einzelnen
                    Datenschutztexten.<br />
                    &#x1f4c5; Speicherdauer: meisten werden die Daten solange gespeichert, bis sie
                    zur Erfüllung der Dienstleistung nicht mehr benötigt werden<br />
                    &#x2696;&#xfe0f; Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung),
                    Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </td>
            </tr>
        </tbody>
    </table>
    <h3 class="adsimple-113004805">Was ist eine Security- &amp; Anti-Spam-Software?</h3>
    <p>
        Mit sogenannten Security- &amp; Anti-Spam-Softwares können Sie sich und wir uns vor diversen
        Spam- oder Phishing-Mails und möglichen anderen Cyberattacken schützen. Unter Spam versteht
        man Werbemails aus einem Massenversand, die man selbst nicht verlangte. Solche Mails werden
        auch Datenmüll genannt und können auch Kosten verursachen. Phishing-Mails sind wiederum
        Nachrichten, die darauf abzielen, über gefälschte Nachrichten oder Websites Vertrauen
        aufzubauen, um an persönliche Daten zu gelangen. Eine Anti-Spam-Software schützt in der
        Regel vor unerwünschten Spam-Nachrichten oder bösartigen Mails, die etwa Viren in unser
        System einschleusen könnten. Wir nutzen auch allgemeine Firewall- und Sicherheitssysteme,
        die unsere Computer vor unerwünschten Netzwerkangriffen schützen.
    </p>
    <h3 class="adsimple-113004805">Warum verwenden wir Security- &amp; Anti-Spam-Software?</h3>
    <p>
        Wir legen auf unserer Website besonders großen Wert auf Sicherheit. Schließlich geht es
        nicht nur um unsere, sondern vor allem auch um Ihre Sicherheit. Leider gehören mittlerweile
        in der Welt der IT und des Internets Cyberbedrohungen schon zum Alltag. Oft versuchen Hacker
        mit Hilfe einer Cyberattacke personenbezogene Daten aus einem IT-System zu stehlen. Und
        daher ist ein gutes Abwehrsystem absolut notwendig. Ein Sicherheitssystem überwacht alle
        ein- und ausgehenden Verbindungen zu unserem Netzwerk bzw. Computer. Damit wir noch größere
        Sicherheit vor Cyberangriffen erreichen, nutzen wir neben den standardisierten
        Sicherheitssystemen auf unserem Computer auch noch weitere externe Security-Dienste.
        Unerlaubter Verkehr von Daten wird dadurch besser unterbunden und so schützen wir uns vor
        Cyberkriminalität.
    </p>
    <h3 class="adsimple-113004805">
        Welche Daten werden durch Security- &amp; Anti-Spam-Softwares verarbeitet?
    </h3>
    <p>
        Welche Daten genau erhoben und gespeichert werden hängt natürlich vom jeweiligen Dienst ab.
        Wir sind allerdings stets bemüht nur Programme zu verwenden, die sehr sparsam Daten erheben
        bzw. nur Daten speichern, die für die Erfüllung der angebotenen Leistung nötig sind.
        Grundsätzlich kann der Dienst Daten wie beispielsweise Name, Adresse, IP-Adresse,
        E-Mail-Adresse und technische Daten wie Browsertyp oder Browserversion speichern. Auch
        können etwaige Leistungs- und Protokolldaten erhoben werden, um mögliche eingehende
        Bedrohungen rechtzeitig zu erkennen. Diese Daten werden im Rahmen der Services und unter
        Einhaltung der geltenden Gesetze verarbeitet. Dazu zählt auch bei US-amerikanischen
        Anbietern (über die Standardvertragsklauseln) die DSGVO. Diese Security-Dienste arbeiten in
        einigen Fällen auch mit Drittanbietern zusammen, die unter Anweisung und in Übereinstimmung
        mit den Datenschutzrichtlinien und weiteren Sicherheitsmaßnahmen Daten speichern und/oder
        verarbeiten können. Die Datenspeicherung erfolgt meist über Cookies.
    </p>
    <h3 class="adsimple-113004805">Dauer der Datenverarbeitung</h3>
    <p>
        Über die Dauer der Datenverarbeitung informieren wir Sie weiter unten, sofern wir weitere
        Informationen dazu haben. Beispielsweise speichern Security-Programme Daten bis Sie oder wir
        die Datenspeicherung widerrufen. Generell werden personenbezogene Daten nur so lange, wie es
        für die Bereitstellung der Dienstleistungen unbedingt notwendig ist, gespeichert. In vielen
        Fällen fehlen uns leider von den Anbietern präzise Informationen über die Länge der
        Speicherung.
    </p>
    <h3 class="adsimple-113004805">Widerspruchsrecht</h3>
    <p>
        Sie haben auch jederzeit das Recht und die Möglichkeit Ihre Einwilligung zur Verwendung von
        Cookies bzw. Drittanbietern von Security-Software zu widerrufen. Das funktioniert entweder
        über unser Cookie-Management-Tool oder über andere Opt-Out-Funktionen. Zum Beispiel können
        Sie auch die Datenerfassung durch Cookies verhindern, indem Sie in Ihrem Browser die Cookies
        verwalten, deaktivieren oder löschen.
    </p>
    <p>
        Da bei solchen Sicherheitsdiensten auch Cookies zum Einsatz kommen können, empfehlen wir
        Ihnen unsere allgemeine Datenschutzerklärung über Cookies. Um zu erfahren, welche Daten von
        Ihnen genau gespeichert und verarbeitet werden, sollten Sie die Datenschutzerklärungen der
        jeweiligen Tools durchlesen.
    </p>
    <h3 class="adsimple-113004805">Rechtsgrundlage</h3>
    <p>
        Wir setzen die Sicherheitsdienste hauptsächlich auf Grundlage unserer berechtigten
        Interessen (Art. 6 Abs. 1 lit. f DSGVO) an einem guten Sicherheitssystem gegen diverse
        Cyberangriffe ein.
    </p>
    <p>
        Bestimmte Verarbeitungen, insbesondere der Einsatz von Cookies sowie die Nutzung von
        Sicherheitsfunktionen bedürfen Ihrer Einwilligung. Wenn Sie eingewilligt haben, dass Daten
        von Ihnen durch eingebundene Security-Dienste verarbeitet und gespeichert werden können,
        gilt diese Einwilligung als Rechtsgrundlage der Datenverarbeitung (Art. 6 Abs. 1 lit. a
        DSGVO). Die meisten von uns verwendeten Dienste setzen Cookies in Ihrem Browser, um Daten zu
        speichern. Darum empfehlen wir Ihnen, unseren Datenschutztext über Cookies genau
        durchzulesen und die Datenschutzerklärung oder die Cookie-Richtlinien des jeweiligen
        Dienstanbieters anzusehen.
    </p>
    <p>
        Informationen zu speziellen Tools erfahren Sie &#8211; sofern vorhanden &#8211; in den
        folgenden Abschnitten.
    </p>
    <h2 id="google-recaptcha-datenschutzerklaerung" class="adsimple-113004805">
        Google reCAPTCHA Datenschutzerklärung
    </h2>
    <table border="1" cellpadding="15">
        <tbody>
            <tr>
                <td>
                    <strong class="adsimple-113004805"
                        >Google reCAPTCHA Datenschutzerklärung Zusammenfassung</strong
                    >
                    <br />
                    &#x1f465; Betroffene: Besucher der Website<br />
                    &#x1f91d; Zweck: Optimierung unserer Serviceleistung und Schutz vor
                    Cyberangriffen<br />
                    &#x1f4d3; Verarbeitete Daten: Daten wie etwa IP-Adresse, Browserinformationen,
                    Ihr Betriebssystem, eingeschränkte Standorts- und Nutzungsdaten<br />
                    Mehr Details dazu finden Sie weiter unten in dieser Datenschutzerklärung.<br />
                    &#x1f4c5; Speicherdauer: abhängig von den gespeicherten Daten<br />
                    &#x2696;&#xfe0f; Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung),
                    Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </td>
            </tr>
        </tbody>
    </table>
    <h3 class="adsimple-113004805">Was ist reCAPTCHA?</h3>
    <p>
        Unser oberstes Ziel ist es, unsere Webseite für Sie und für uns bestmöglich zu sichern und
        zu schützen. Um das zu gewährleisten, verwenden wir Google reCAPTCHA der Firma Google Inc.
        Für den europäischen Raum ist das Unternehmen Google Ireland Limited (Gordon House, Barrow
        Street Dublin 4, Irland) für alle Google-Dienste verantwortlich. Mit reCAPTCHA können wir
        feststellen, ob Sie auch wirklich ein Mensch aus Fleisch und Blut sind und kein Roboter oder
        eine andere Spam-Software. Unter Spam verstehen wir jede, auf elektronischen Weg,
        unerwünschte Information, die uns ungefragter Weise zukommt. Bei den klassischen CAPTCHAS
        mussten Sie zur Überprüfung meist Text- oder Bildrätsel lösen. Mit reCAPTCHA von Google
        müssen wir Sie meist nicht mit solchen Rätseln belästigen. Hier reicht es in den meisten
        Fällen, wenn Sie einfach ein Häkchen setzen und so bestätigen, dass Sie kein Bot sind. Mit
        der neuen Invisible reCAPTCHA Version müssen Sie nicht mal mehr ein Häkchen setzen. Wie das
        genau funktioniert und vor allem welche Daten dafür verwendet werden, erfahren Sie im
        Verlauf dieser Datenschutzerklärung.
    </p>
    <p>
        reCAPTCHA ist ein freier Captcha-Dienst von Google, der Webseiten vor Spam-Software und den
        Missbrauch durch nicht-menschliche Besucher schützt. Am häufigsten wird dieser Dienst
        verwendet, wenn Sie Formulare im Internet ausfüllen. Ein Captcha-Dienst ist eine Art
        automatischer Turing-Test, der sicherstellen soll, dass eine Handlung im Internet von einem
        Menschen und nicht von einem Bot vorgenommen wird. Im klassischen Turing-Test (benannt nach
        dem Informatiker Alan Turing) stellt ein Mensch die Unterscheidung zwischen Bot und Mensch
        fest. Bei Captchas übernimmt das auch der Computer bzw. ein Softwareprogramm. Klassische
        Captchas arbeiten mit kleinen Aufgaben, die für Menschen leicht zu lösen sind, doch für
        Maschinen erhebliche Schwierigkeiten aufweisen. Bei reCAPTCHA müssen Sie aktiv keine Rätsel
        mehr lösen. Das Tool verwendet moderne Risikotechniken, um Menschen von Bots zu
        unterscheiden. Hier müssen Sie nur noch das Textfeld „Ich bin kein Roboter“ ankreuzen bzw.
        bei Invisible reCAPTCHA ist selbst das nicht mehr nötig. Bei reCAPTCHA wird ein
        JavaScript-Element in den Quelltext eingebunden und dann läuft das Tool im Hintergrund und
        analysiert Ihr Benutzerverhalten. Aus diesen Useraktionen berechnet die Software einen
        sogenannten Captcha-Score. Google berechnet mit diesem Score schon vor der Captcha-Eingabe
        wie hoch die Wahrscheinlichkeit ist, dass Sie ein Mensch sind. reCAPTCHA bzw. Captchas im
        Allgemeinen kommen immer dann zum Einsatz, wenn Bots gewisse Aktionen (wie z.B.
        Registrierungen, Umfragen usw.) manipulieren oder missbrauchen könnten.
    </p>
    <h3 class="adsimple-113004805">Warum verwenden wir reCAPTCHA auf unserer Website?</h3>
    <p>
        Wir wollen nur Menschen aus Fleisch und Blut auf unserer Seite begrüßen. Bots oder
        Spam-Software unterschiedlichster Art dürfen getrost zuhause bleiben. Darum setzen wir alle
        Hebel in Bewegung, uns zu schützen und die bestmögliche Benutzerfreundlichkeit für Sie
        anzubieten. Aus diesem Grund verwenden wir Google reCAPTCHA der Firma Google. So können wir
        uns ziemlich sicher sein, dass wir eine „botfreie“ Webseite bleiben. Durch die Verwendung
        von reCAPTCHA werden Daten an Google übermittelt, um festzustellen, ob Sie auch wirklich ein
        Mensch sind. reCAPTCHA dient also der Sicherheit unserer Webseite und in weiterer Folge
        damit auch Ihrer Sicherheit. Zum Beispiel könnte es ohne reCAPTCHA passieren, dass bei einer
        Registrierung ein Bot möglichst viele E-Mail-Adressen registriert, um im Anschluss Foren
        oder Blogs mit unerwünschten Werbeinhalten „zuzuspamen“. Mit reCAPTCHA können wir solche
        Botangriffe vermeiden.
    </p>
    <h3 class="adsimple-113004805">Welche Daten werden von reCAPTCHA gespeichert?</h3>
    <p>
        reCAPTCHA sammelt personenbezogene Daten von Usern, um festzustellen, ob die Handlungen auf
        unserer Webseite auch wirklich von Menschen stammen. Es kann also die IP-Adresse und andere
        Daten, die Google für den reCAPTCHA-Dienst benötigt, an Google versendet werden. IP-Adressen
        werden innerhalb der Mitgliedstaaten der EU oder anderer Vertragsstaaten des Abkommens über
        den Europäischen Wirtschaftsraum fast immer zuvor gekürzt, bevor die Daten auf einem Server
        in den USA landen. Die IP-Adresse wird nicht mit anderen Daten von Google kombiniert, sofern
        Sie nicht während der Verwendung von reCAPTCHA mit Ihrem Google-Konto angemeldet sind.
        Zuerst prüft der reCAPTCHA-Algorithmus, ob auf Ihrem Browser schon Google-Cookies von
        anderen Google-Diensten (YouTube. Gmail usw.) platziert sind. Anschließend setzt reCAPTCHA
        ein zusätzliches Cookie in Ihrem Browser und erfasst einen Schnappschuss Ihres
        Browserfensters.
    </p>
    <p>
        Die folgende Liste von gesammelten Browser- und Userdaten, hat nicht den Anspruch auf
        Vollständigkeit. Vielmehr sind es Beispiele von Daten, die nach unserer Erkenntnis, von
        Google verarbeitet werden.
    </p>
    <ul class="adsimple-113004805">
        <li class="adsimple-113004805">
            Referrer URL (die Adresse der Seite von der der Besucher kommt)
        </li>
        <li class="adsimple-113004805">IP-Adresse (z.B. 256.123.123.1)</li>
        <li class="adsimple-113004805">
            Infos über das Betriebssystem (die Software, die den Betrieb Ihres Computers ermöglicht.
            Bekannte Betriebssysteme sind Windows, Mac OS X oder Linux)
        </li>
        <li class="adsimple-113004805">
            Cookies (kleine Textdateien, die Daten in Ihrem Browser speichern)
        </li>
        <li class="adsimple-113004805">
            Maus- und Keyboardverhalten (jede Aktion, die Sie mit der Maus oder der Tastatur
            ausführen wird gespeichert)
        </li>
        <li class="adsimple-113004805">
            Datum und Spracheinstellungen (welche Sprache bzw. welches Datum Sie auf Ihrem PC
            voreingestellt haben wird gespeichert)
        </li>
        <li class="adsimple-113004805">
            Alle Javascript-Objekte (JavaScript ist eine Programmiersprache, die Webseiten
            ermöglicht, sich an den User anzupassen. JavaScript-Objekte können alle möglichen Daten
            unter einem Namen sammeln)
        </li>
        <li class="adsimple-113004805">
            Bildschirmauflösung (zeigt an aus wie vielen Pixeln die Bilddarstellung besteht)
        </li>
    </ul>
    <p>
        Unumstritten ist, dass Google diese Daten verwendet und analysiert noch bevor Sie auf das
        Häkchen „Ich bin kein Roboter“ klicken. Bei der Invisible reCAPTCHA-Version fällt sogar das
        Ankreuzen weg und der ganze Erkennungsprozess läuft im Hintergrund ab. Wie viel und welche
        Daten Google genau speichert, erfährt man von Google nicht im Detail.
    </p>
    <p>
        Folgende Cookies werden von reCAPTCHA verwendet: Hierbei beziehen wir uns auf die reCAPTCHA
        Demo-Version von Google unter
        <a
            class="adsimple-113004805"
            href="https://www.google.com/recaptcha/api2/demo"
            target="_blank"
            rel="noopener noreferrer"
            >https://www.google.com/recaptcha/api2/demo</a
        >. All diese Cookies benötigen zu Trackingzwecken eine eindeutige Kennung. Hier ist eine
        Liste an Cookies, die Google reCAPTCHA auf der Demo-Version gesetzt hat:
    </p>
    <p>
        <strong class="adsimple-113004805">Name:</strong> IDE<br />
        <strong class="adsimple-113004805">Wert:</strong
        > WqTUmlnmv_qXyi_DGNPLESKnRNrpgXoy1K-pAZtAkMbHI-113004805-8<br />
        <strong class="adsimple-113004805">Verwendungszweck:</strong> Dieses Cookie wird von der
        Firma DoubleClick (gehört auch Google) gesetzt, um die Aktionen eines Users auf der Webseite
        im Umgang mit Werbeanzeigen zu registrieren und zu melden. So kann die Werbewirksamkeit
        gemessen und entsprechende Optimierungsmaßnahmen getroffen werden. IDE wird in Browsern
        unter der Domain doubleclick.net gespeichert.<br />
        <strong class="adsimple-113004805">Ablaufdatum:</strong> nach einem Jahr
    </p>
    <p>
        <strong class="adsimple-113004805">Name:</strong> 1P_JAR<br />
        <strong class="adsimple-113004805">Wert:</strong> 2019-5-14-12<br />
        <strong class="adsimple-113004805">Verwendungszweck:</strong> Dieses Cookie sammelt
        Statistiken zur Webseite-Nutzung und misst Conversions. Eine Conversion entsteht z.B., wenn
        ein User zu einem Käufer wird. Das Cookie wird auch verwendet, um Usern relevante
        Werbeanzeigen einzublenden. Weiters kann man mit dem Cookie vermeiden, dass ein User
        dieselbe Anzeige mehr als einmal zu Gesicht bekommt.<br />
        <strong class="adsimple-113004805">Ablaufdatum:</strong> nach einem Monat
    </p>
    <p>
        <strong class="adsimple-113004805">Name:</strong> ANID<br />
        <strong class="adsimple-113004805">Wert:</strong> U7j1v3dZa1130048050xgZFmiqWppRWKOr<br />
        <strong class="adsimple-113004805">Verwendungszweck:</strong> Viele Infos konnten wir über
        dieses Cookie nicht in Erfahrung bringen. In der Datenschutzerklärung von Google wird das
        Cookie im Zusammenhang mit „Werbecookies“ wie z. B. &#8220;DSID&#8221;, &#8220;FLC&#8221;,
        &#8220;AID&#8221;, &#8220;TAID&#8221; erwähnt. ANID wird unter Domain google.com
        gespeichert.<br />
        <strong class="adsimple-113004805">Ablaufdatum:</strong> nach 9 Monaten
    </p>
    <p>
        <strong class="adsimple-113004805">Name:</strong> CONSENT<br />
        <strong class="adsimple-113004805">Wert: </strong>YES+AT.de+20150628-20-0<br />
        <strong class="adsimple-113004805">Verwendungszweck:</strong> Das Cookie speichert den
        Status der Zustimmung eines Users zur Nutzung unterschiedlicher Services von Google. CONSENT
        dient auch der Sicherheit, um User zu überprüfen, Betrügereien von Anmeldeinformationen zu
        verhindern und Userdaten vor unbefugten Angriffen zu schützen.<br />
        <strong class="adsimple-113004805">Ablaufdatum:</strong> nach 19 Jahren
    </p>
    <p>
        <strong class="adsimple-113004805">Name:</strong> NID<br />
        <strong class="adsimple-113004805">Wert:</strong> 0WmuWqy113004805zILzqV_nmt3sDXwPeM5Q<br />
        <strong class="adsimple-113004805">Verwendungszweck:</strong> NID wird von Google verwendet,
        um Werbeanzeigen an Ihre Google-Suche anzupassen. Mit Hilfe des Cookies „erinnert“ sich
        Google an Ihre meist eingegebenen Suchanfragen oder Ihre frühere Interaktion mit Anzeigen.
        So bekommen Sie immer maßgeschneiderte Werbeanzeigen. Das Cookie enthält eine einzigartige
        ID, um persönliche Einstellungen des Users für Werbezwecke zu sammeln.<br />
        <strong class="adsimple-113004805">Ablaufdatum:</strong> nach 6 Monaten
    </p>
    <p>
        <strong class="adsimple-113004805">Name:</strong> DV<br />
        <strong class="adsimple-113004805">Wert:</strong> gEAABBCjJMXcI0dSAAAANbqc113004805-4<br />
        <strong class="adsimple-113004805">Verwendungszweck:</strong> Sobald Sie das „Ich bin kein
        Roboter“-Häkchen angekreuzt haben, wird dieses Cookie gesetzt. Das Cookie wird von Google
        Analytics für personalisierte Werbung verwendet. DV sammelt Informationen in anonymisierter
        Form und wird weiters benutzt, um User-Unterscheidungen zu treffen.<br />
        <strong class="adsimple-113004805">Ablaufdatum:</strong> nach 10 Minuten
    </p>
    <p>
        <strong class="adsimple-113004805">Anmerkung: </strong>Diese Aufzählung kann keinen Anspruch
        auf Vollständigkeit erheben, da Google erfahrungsgemäß die Wahl ihrer Cookies immer wieder
        auch verändert.
    </p>
    <h3 class="adsimple-113004805">Wie lange und wo werden die Daten gespeichert?</h3>
    <p>
        Durch das Einfügen von reCAPTCHA werden Daten von Ihnen auf den Google-Server übertragen. Wo
        genau diese Daten gespeichert werden, stellt Google, selbst nach wiederholtem Nachfragen,
        nicht klar dar. Ohne eine Bestätigung von Google erhalten zu haben, ist davon auszugehen,
        dass Daten wie Mausinteraktion, Verweildauer auf der Webseite oder Spracheinstellungen auf
        den europäischen oder amerikanischen Google-Servern gespeichert werden. Die IP-Adresse, die
        Ihr Browser an Google übermittelt, wird grundsätzlich nicht mit anderen Google-Daten aus
        weiteren Google-Diensten zusammengeführt. Wenn Sie allerdings während der Nutzung des
        reCAPTCHA-Plug-ins bei Ihrem Google-Konto angemeldet sind, werden die Daten
        zusammengeführt.<strong class="adsimple-113004805"> </strong>Dafür gelten die abweichenden
        Datenschutzbestimmungen der Firma Google.
    </p>
    <h3 class="adsimple-113004805">
        Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?
    </h3>
    <p>
        Wenn Sie wollen, dass über Sie und über Ihr Verhalten keine Daten an Google übermittelt
        werden, müssen Sie sich, bevor Sie unsere Webseite besuchen bzw. die reCAPTCHA-Software
        verwenden, bei Google vollkommen ausloggen und alle Google-Cookies löschen. Grundsätzlich
        werden die Daten sobald Sie unsere Seite aufrufen automatisch an Google übermittelt. Um
        diese Daten wieder zu löschen, müssen Sie den Google-Support auf 
        <a
            class="adsimple-113004805"
            href="https://support.google.com/?hl=de&amp;tid=113004805"
            target="_blank"
            rel="noopener noreferrer"
            >https://support.google.com/?hl=de&amp;tid=113004805</a
        >
        kontaktieren.
    </p>
    <p>
        Wenn Sie also unsere Webseite verwenden, erklären Sie sich einverstanden, dass Google LLC
        und deren Vertreter automatisch Daten erheben, bearbeiten und nutzen.
    </p>
    <p>
        Bitte beachten Sie, dass bei der Verwendung dieses Tools Daten von Ihnen auch außerhalb der
        EU gespeichert und verarbeitet werden können. Die meisten Drittstaaten (darunter auch die
        USA) gelten nach derzeitigem europäischen Datenschutzrecht als nicht sicher. Daten an
        unsichere Drittstaaten dürfen also nicht einfach übertragen, dort gespeichert und
        verarbeitet werden, sofern es keine passenden Garantien (wie etwa
        EU-Standardvertragsklauseln) zwischen uns und dem außereuropäischen Dienstleister gibt.
    </p>
    <h3 class="adsimple-113004805">Rechtsgrundlage</h3>
    <p>
        Wenn Sie eingewilligt haben, dass Google reCAPTCHA eingesetzt werden darf, ist die
        Rechtsgrundlage der entsprechenden Datenverarbeitung diese Einwilligung. Diese Einwilligung
        stellt laut<strong class="adsimple-113004805">
            Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</strong
        >
        die Rechtsgrundlage für die Verarbeitung personenbezogener Daten, wie sie bei der Erfassung
        durch Google reCAPTCHA vorkommen kann, dar.
    </p>
    <p>
        Von unserer Seite besteht zudem ein berechtigtes Interesse, Google reCAPTCHA zu verwenden,
        um unser Online-Service zu optimieren und sicherer zu machen. Die dafür entsprechende
        Rechtsgrundlage ist
        <strong class="adsimple-113004805"
            >Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)</strong
        >. Wir setzen Google reCAPTCHA gleichwohl nur ein, soweit Sie eine Einwilligung erteilt
        haben.
    </p>
    <p>
        Google verarbeitet Daten von Ihnen u.a. auch in den USA. Google ist aktiver Teilnehmer des
        EU-US Data Privacy Frameworks, wodurch der korrekte und sichere Datentransfer
        personenbezogener Daten von EU-Bürgern in die USA geregelt wird. Mehr Informationen dazu
        finden Sie auf
        <a
            class="adsimple-113004805"
            href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
            target="_blank"
            rel="follow noopener"
            >https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en</a
        >.
    </p>
    <p>
        Zudem verwendet Google sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3 DSGVO).
        Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind von der EU-Kommission
        bereitgestellte Mustervorlagen und sollen sicherstellen, dass Ihre Daten auch dann den
        europäischen Datenschutzstandards entsprechen, wenn diese in Drittländer (wie beispielsweise
        in die USA) überliefert und dort gespeichert werden. Durch das EU-US Data Privacy Framework
        und durch die Standardvertragsklauseln verpflichtet sich Google, bei der Verarbeitung Ihrer
        relevanten Daten, das europäische Datenschutzniveau einzuhalten, selbst wenn die Daten in
        den USA gespeichert, verarbeitet und verwaltet werden. Diese Klauseln basieren auf einem
        Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und die entsprechenden
        Standardvertragsklauseln u.a. hier:
        <a
            class="adsimple-113004805"
            href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
            target="_blank"
            rel="follow noopener"
            >https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de</a
        >
    </p>
    <p>
        Die Google Ads Datenverarbeitungsbedingungen (Google Ads Data Processing Terms), welche auf
        die Standardvertragsklauseln verweisen, finden Sie unter
        <a
            class="adsimple-113004805"
            href="https://business.safety.google/intl/de/adsprocessorterms/"
            target="_blank"
            rel="follow noopener"
            >https://business.safety.google/intl/de/adsprocessorterms/</a
        >.
    </p>
    <p>
        Etwas mehr über reCAPTCHA erfahren Sie auf der Webentwickler-Seite von Google auf
        <a
            class="adsimple-113004805"
            href="https://developers.google.com/recaptcha/"
            target="_blank"
            rel="noopener noreferrer"
            >https://developers.google.com/recaptcha/</a
        >. Google geht hier zwar auf die technische Entwicklung der reCAPTCHA näher ein, doch genaue
        Informationen über Datenspeicherung und datenschutzrelevanten Themen sucht man auch dort
        vergeblich. Eine gute Übersicht über die grundsätzliche Verwendung von Daten bei Google
        finden Sie in der hauseigenen Datenschutzerklärung auf
        <a class="adsimple-113004805" href="https://policies.google.com/privacy?tid=113004805"
            >https://policies.google.com/privacy</a
        >.
    </p>
    <h2 id="online-buchungssysteme-einleitung" class="adsimple-113004805">
        Online-Buchungssysteme Einleitung
    </h2>
    <table border="1" cellpadding="15">
        <tbody>
            <tr>
                <td>
                    <strong class="adsimple-113004805"
                        >Online-Buchungssysteme Datenschutzerklärung Zusammenfassung</strong
                    >
                    <br />
                    &#x1f465; Betroffene: Besucher der Website<br />
                    &#x1f91d; Zweck: Verbesserung der Nutzererfahrung und Organisation<br />
                    &#x1f4d3; Verarbeitete Daten: Welche Daten verarbeitet werden, hängt stark von
                    den verwendeten Diensten ab. Meist handelt es sich um IP-Adresse, Kontakt- und
                    Bezahldaten und/oder technische Daten. Mehr Details dazu finden Sie bei den
                    jeweils eingesetzten Tools.<br />
                    &#x1f4c5; Speicherdauer: abhängig von den eingesetzten Tools<br />
                    &#x2696;&#xfe0f; Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung),
                    Art. 6 Abs. 1 lit. f DSGVO (Berechtigte Interessen)
                </td>
            </tr>
        </tbody>
    </table>
    <h3 class="adsimple-113004805">Was ist ein Online-Buchungssystem?</h3>
    <p>
        Damit Sie über unsere Website Buchungen vornehmen können, nutzen wir ein oder mehrere
        Buchungssysteme. Termine etwa können so ganz einfach online erstellt werden. Ein
        Buchungssystem ist eine in unsere Website eingebundene Softwareanwendung, die verfügbare
        Ressourcen (wie zum Beispiel freie Termine) anzeigt und über die Sie direkt online buchen
        und meist auch bezahlen können. Sie kennen wahrscheinlich solche Buchungssysteme bereits aus
        der Gastronomie oder Hotellerie. Mittlerweile werden solche Systeme aber in den
        verschiedensten Branchen angewandt. Buchungssysteme können je nach Tool und Einstellungen
        sowohl intern für uns als auch für Kunden wie Sie genutzt werden. Dabei werden in der Regel
        auch personenbezogene Daten von Ihnen erhoben und gespeichert.
    </p>
    <p>
        Meistens funktioniert die Buchung wie folgt: Sie finden auf unsere Website das
        Buchungssystem, in dem Sie per Mausklick und Angaben Ihrer Daten direkt einen Termin für
        eine Dienstleistung buchen und meist auch gleich bezahlen können. Es kann sein, dass Sie
        über ein Formular verschiedene Angaben über Ihre Person eintragen können. Bitte seien Sie
        sich bewusst, dass alle von Ihnen eingegebenen Daten in einer Datenbank gespeichert und
        verwaltet werden können.
    </p>
    <h3 class="adsimple-113004805">Warum nutzen wir ein Online-Buchungssystem?</h3>
    <p>
        Wir verstehen unsere Website in gewisser Weise auch als freie Dienstleistung für Sie. Sie
        sollen hilfreiche Informationen erhalten und sich auf unsere Seite rundum wohl fühlen. Dazu
        gehört auch ein Online-Service, das Ihnen das Buchen von Terminen bzw. Dienstleistungen so
        einfach wie möglich macht. Vorbei sind die Zeiten, in denen Sie umständlich via Telefon oder
        E-Mail tagelang auf eine Buchungsbestätigung warten mussten. Mit einem Online-Buchungssystem
        haben Sie nach wenigen Klicks alles erledigt und können sich wieder um andere Dinge kümmern.
        Auch für uns erleichtert das System das Management aller Buchungen und Termine. Daher
        betrachten wir ein solches Buchungssystem sowohl für Sie als auch für uns als absolut
        sinnvoll.
    </p>
    <h3 class="adsimple-113004805">Welche Daten werden verarbeitet?</h3>
    <p>
        Welche Daten genau verarbeitet werden, können wir Ihnen in diesem allgemeinen
        Informationstext über Buchungssystem natürlich nicht sagen. Das ist stets vom verwendeten
        Tool und den darin enthaltenen Funktionen und Möglichkeiten abhängig. Viele Buchungssysteme
        bieten neben der herkömmlichen Buchungsfunktion auch noch eine Reihe an weiteren Features
        an. So haben beispielsweise viele Systeme auch ein externes Online-Zahlsystem (z. B. von
        Stripe, Klarna oder Paypal) und eine Kalender-Synchronisierungsfunktion integriert.
        Dementsprechend können je nach Funktionen unterschiedliche und unterschiedlich viele Daten
        verarbeitet werden. Für gewöhnlich werden Daten wie IP-Adresse, Name und Kontaktdaten,
        technische Angaben zu Ihrem Gerät und Zeitpunkt einer Buchung verarbeitet. Wenn Sie im
        System auch eine Zahlung vornehmen, werden auch Bankdaten wie Kontonummer,
        Kreditkartennummer, Passwörter, TANs usw. gespeichert und an den jeweiligen Zahlungsanbieter
        weitergegeben. Wir empfehlen Ihnen die jeweilige Datenschutzerklärung des verwendeten Tools
        genau durchzulesen, damit Sie wissen, welche Daten von Ihnen konkret verarbeitet werden.
    </p>
    <h3 class="adsimple-113004805">Dauer der Datenverarbeitung</h3>
    <p>
        Jedes Buchungssystem speichert Daten unterschiedlich lange. Darum können wir über die Dauer
        der Datenverarbeitung hier noch keine konkreten Angaben geben. Grundsätzlich werden
        allerdings personenbezogene Daten immer nur so lange gespeichert, wie es zur Bereitstellung
        der Dienste unbedingt nötig ist. Buchungssystem verwenden in der Regel auch Cookies, die
        Informationen unterschiedlich lange speichern. Manche Cookies werden sofort nach Verlassen
        der Seite wieder gelöscht, andere können einige Jahre gespeichert werden. In unserem
        Abschnitt „Cookies“ erfahren Sie mehr darüber. Schauen Sie sich bitte auch die jeweiligen
        Datenschutzerklärungen der Anbieter an. Darin sollte erläutert werden, wie lange Ihre Daten
        im konkreten Fall gespeichert werden.
    </p>
    <h3 class="adsimple-113004805">Widerspruchsrecht</h3>
    <p>
        Wenn Sie der Datenverarbeitung durch ein Buchungssystem zugestimmt haben, haben Sie
        natürlich auch immer die Möglichkeit und das Recht diese Einwilligung zu widerrufen. Seien
        Sie sich also bitte stets bewusst, dass Sie Rechte in Bezug auf Ihre personenbezogenen Daten
        haben und diese Rechte auch jederzeit wirkend machen können. Wenn Sie nicht wollen, dass
        personenbezogene Daten verarbeitet werden, dann dürfen auch keine personenbezogenen Daten
        verarbeitet werden. So einfach ist das. Am einfachsten widerrufen Sie die Datenverarbeitung
        über ein Cookie-Consent-Tool oder über andere angebotene Opt-Out-Funktionen. Die
        Datenspeicherung durch Cookies können Sie zum Beispiel auch direkt in Ihrem Browser
        verwalten. Bis zu Ihrem Widerruf bleibt die Rechtmäßigkeit der Datenverwaltung unberührt.
    </p>
    <h3 class="adsimple-113004805">Rechtsgrundlage</h3>
    <p>
        Wenn Sie eingewilligt haben, dass Buchungssysteme eingesetzt werden dürfen, ist die
        Rechtsgrundlage der entsprechenden Datenverarbeitung diese Einwilligung. Sie stellt laut
        Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) die Rechtsgrundlage für die Verarbeitung
        personenbezogener Daten, wie sie durch Buchungssysteme vorkommen kann, dar.
    </p>
    <p>
        Weiters haben auch wir ein berechtigtes Interesse, Buchungssysteme zu verwenden, weil wir
        damit einerseits unser Kundenservice erweitern und andererseits unsere interne
        Buchungsorganisation optimieren. Die dafür entsprechende Rechtsgrundlage ist Art. 6 Abs. 1
        lit. f DSGVO (Berechtigte Interessen). Wir setzen die Tools gleichwohl nur ein, soweit Sie
        eine Einwilligung erteilt haben. Das wollen wir an dieser Stelle unbedingt nochmals
        festgehalten haben.
    </p>
    <p>
        Informationen zu speziellen Buchungssystemen erhalten Sie &#8211; sofern vorhanden &#8211;
        in den folgenden Abschnitten.
    </p>
    <h2 id="calendly-datenschutzerklaerung" class="adsimple-113004805">
        Calendly Datenschutzerklärung
    </h2>
    <p>
        Wir nutzen auch das Online-Buchungssystem Calendly. Dienstanbieter ist das amerikanische
        Unternehmen Calendly Inc., 115 E. Main St., Ste A1B, Buford, GA 30518, USA.
    </p>
    <p>
        Calendly verarbeitet Daten von Ihnen u.a. auch in den USA. Calendly ist aktiver Teilnehmer
        des EU-US Data Privacy Frameworks, wodurch der korrekte und sichere Datentransfer
        personenbezogener Daten von EU-Bürgern in die USA geregelt wird. Mehr Informationen dazu
        finden Sie auf
        <a
            class="adsimple-113004805"
            href="https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en"
            target="_blank"
            rel="follow noopener"
            >https://commission.europa.eu/document/fa09cbad-dd7d-4684-ae60-be03fcb0fddf_en</a
        >.
    </p>
    <p>
        Zudem verwendet Calendly sogenannte Standardvertragsklauseln (= Art. 46. Abs. 2 und 3
        DSGVO). Standardvertragsklauseln (Standard Contractual Clauses – SCC) sind von der
        EU-Kommission bereitgestellte Mustervorlagen und sollen sicherstellen, dass Ihre Daten auch
        dann den europäischen Datenschutzstandards entsprechen, wenn diese in Drittländer (wie
        beispielsweise in die USA) überliefert und dort gespeichert werden. Durch das EU-US Data
        Privacy Framework und durch die Standardvertragsklauseln verpflichtet sich Calendly, bei der
        Verarbeitung Ihrer relevanten Daten, das europäische Datenschutzniveau einzuhalten, selbst
        wenn die Daten in den USA gespeichert, verarbeitet und verwaltet werden. Diese Klauseln
        basieren auf einem Durchführungsbeschluss der EU-Kommission. Sie finden den Beschluss und
        die entsprechenden Standardvertragsklauseln u.a. hier:
        <a
            class="adsimple-113004805"
            href="https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de"
            target="_blank"
            rel="follow noopener"
            >https://eur-lex.europa.eu/eli/dec_impl/2021/914/oj?locale=de</a
        >.
    </p>
    <p>
        Mehr Informationen zu den Standardvertragsklauseln bei Calendly finden Sie in den
        Datenverarbeitungsbedingungen unter
        <a
            class="adsimple-113004805"
            href="https://calendly.com/dpa"
            target="_blank"
            rel="follow noopener"
            >https://calendly.com/dpa</a
        >.
    </p>
    <p>
        Wir hoffen, wir konnten Ihnen die wichtigsten Informationen rund um die Datenverarbeitung
        von Calendly näherbringen. Mehr über die Daten, die durch die Verwendung von Calendly
        verarbeitet werden, erfahren Sie in der Datenschutzerklärung auf
        <a
            class="adsimple-113004805"
            href="https://calendly.com/privacy?tid=113004805"
            target="_blank"
            rel="follow noopener"
            >https://calendly.com/privacy</a
        >.
    </p>
    <h2 id="erklaerung-verwendeter-begriffe" class="adsimple-113004805">
        Erklärung verwendeter Begriffe
    </h2>
    <p>
        Wir sind stets bemüht unsere Datenschutzerklärung so klar und verständlich wie möglich zu
        verfassen. Besonders bei technischen und rechtlichen Themen ist das allerdings nicht immer
        ganz einfach. Es macht oft Sinn juristische Begriffe (wie z. B. personenbezogene Daten) oder
        bestimmte technische Ausdrücke (wie z. B. Cookies, IP-Adresse) zu verwenden. Wir möchte
        diese aber nicht ohne Erklärung verwenden. Nachfolgend finden Sie nun eine alphabetische
        Liste von wichtigen verwendeten Begriffen, auf die wir in der bisherigen
        Datenschutzerklärung vielleicht noch nicht ausreichend eingegangen sind. Falls diese
        Begriffe der DSGVO entnommen wurden und es sich um Begriffsbestimmungen handelt, werden wir
        hier auch die DSGVO-Texte anführen und gegebenenfalls noch eigene Erläuterungen hinzufügen.
    </p>
    <h2 id="auftragsverarbeiter" class="adsimple-113004805">Auftragsverarbeiter</h2>
    <p>
        <strong class="adsimple-113004805">Begriffsbestimmung nach Artikel 4 der DSGVO</strong>
    </p>
    <p>Im Sinne dieser Verordnung bezeichnet der Ausdruck:</p>
    <blockquote>
        <p>
            <em>
                <strong class="adsimple-113004805">„Auftragsverarbeiter“</strong> eine natürliche
                oder juristische Person, Behörde, Einrichtung oder andere Stelle, die
                personenbezogene Daten im Auftrag des Verantwortlichen verarbeitet;</em
            >
        </p>
    </blockquote>
    <p>
        <strong class="adsimple-113004805">Erläuterung:</strong> Wir sind als Unternehmen und
        Websiteinhaber für alle Daten, die wir von Ihnen verarbeiten verantwortlich. Neben den
        Verantwortlichen kann es auch sogenannte Auftragsverarbeiter geben. Dazu zählt jedes
        Unternehmen bzw. jede Person, die in unserem Auftrag personenbezogene Daten verarbeitet.
        Auftragsverarbeiter können folglich, neben Dienstleistern wie Steuerberater, etwa auch
        Hosting- oder Cloudanbieter, Bezahlungs- oder Newsletter-Anbieter oder große Unternehmen wie
        beispielsweise Google oder Microsoft sein.
    </p>
    <h2 id="einwilligung" class="adsimple-113004805">Einwilligung</h2>
    <p>
        <strong class="adsimple-113004805">Begriffsbestimmung nach Artikel 4 der DSGVO</strong>
    </p>
    <p>Im Sinne dieser Verordnung bezeichnet der Ausdruck:</p>
    <blockquote>
        <p>
            <em>
                <strong class="adsimple-113004805">„Einwilligung“</strong> der betroffenen Person
                jede freiwillig für den bestimmten Fall, in informierter Weise und
                unmissverständlich abgegebene Willensbekundung in Form einer Erklärung oder einer
                sonstigen eindeutigen bestätigenden Handlung, mit der die betroffene Person zu
                verstehen gibt, dass sie mit der Verarbeitung der sie betreffenden personenbezogenen
                Daten einverstanden ist;</em
            >
        </p>
    </blockquote>
    <p>
        <strong class="adsimple-113004805">Erläuterung: </strong>In der Regel erfolgt bei Websites
        eine solche Einwilligung über ein Cookie-Consent-Tool. Sie kennen das bestimmt. Immer wenn
        Sie erstmals eine Website besuchen, werden Sie meist über einen Banner gefragt, ob Sie der
        Datenverarbeitung zustimmen bzw. einwilligen. Meist können Sie auch individuelle
        Einstellungen treffen und so selbst entscheiden, welche Datenverarbeitung Sie erlauben und
        welche nicht. Wenn Sie nicht einwilligen, dürfen auch keine personenbezogene Daten von Ihnen
        verarbeitet werden. Grundsätzlich kann eine Einwilligung natürlich auch schriftlich, also
        nicht über ein Tool, erfolgen.
    </p>
    <h2 id="personenbezogene-daten" class="adsimple-113004805">Personenbezogene Daten</h2>
    <p>
        <strong class="adsimple-113004805">Begriffsbestimmung nach Artikel 4 der DSGVO</strong>
    </p>
    <p>Im Sinne dieser Verordnung bezeichnet der Ausdruck:</p>
    <blockquote>
        <p>
            <strong class="adsimple-113004805">
                <em>„personenbezogene Daten“</em>
            </strong>
            <em>
                alle Informationen, die sich auf eine identifizierte oder identifizierbare
                natürliche Person (im Folgenden „betroffene Person“) beziehen; als identifizierbar
                wird eine natürliche Person angesehen, die direkt oder indirekt, insbesondere
                mittels Zuordnung zu einer Kennung wie einem Namen, zu einer Kennnummer, zu
                Standortdaten, zu einer Online-Kennung oder zu einem oder mehreren besonderen
                Merkmalen, die Ausdruck der physischen, physiologischen, genetischen, psychischen,
                wirtschaftlichen, kulturellen oder sozialen Identität dieser natürlichen Person
                sind, identifiziert werden kann;</em
            >
        </p>
    </blockquote>
    <p>
        <strong class="adsimple-113004805">Erläuterung:</strong> Personenbezogene Daten sind also
        all jene Daten, die Sie als Person identifizieren können. Das sind in der Regel Daten wie
        etwa:
    </p>
    <ul class="adsimple-113004805">
        <li class="adsimple-113004805">Name</li>
        <li class="adsimple-113004805">Adresse</li>
        <li class="adsimple-113004805">E-Mail-Adresse</li>
        <li class="adsimple-113004805">Post-Anschrift</li>
        <li class="adsimple-113004805">Telefonnummer</li>
        <li class="adsimple-113004805">Geburtsdatum</li>
        <li class="adsimple-113004805">
            Kennnummern wie Sozialversicherungsnummer, Steueridentifikationsnummer,
            Personalausweisnummer oder Matrikelnummer
        </li>
        <li class="adsimple-113004805">
            Bankdaten wie Kontonummer, Kreditinformationen, Kontostände uvm.
        </li>
    </ul>
    <p>
        Laut Europäischem Gerichtshof (EuGH) zählt auch Ihre
        <strong class="adsimple-113004805">IP-Adresse zu den personenbezogenen Daten</strong>.
        IT-Experten können anhand Ihrer IP-Adresse zumindest den ungefähren Standort Ihres Geräts
        und in weiterer Folge Sie als Anschlussinhabers feststellen. Daher benötigt auch das
        Speichern einer IP-Adresse eine Rechtsgrundlage im Sinne der DSGVO. Es gibt auch noch
        sogenannte <strong class="adsimple-113004805">„besondere Kategorien“</strong> der
        personenbezogenen Daten, die auch besonders schützenswert sind. Dazu zählen:
    </p>
    <ul class="adsimple-113004805">
        <li class="adsimple-113004805">rassische und ethnische Herkunft</li>
        <li class="adsimple-113004805">politische Meinungen</li>
        <li class="adsimple-113004805">religiöse bzw. weltanschauliche Überzeugungen</li>
        <li class="adsimple-113004805">die Gewerkschaftszugehörigkeit</li>
        <li class="adsimple-113004805">
            genetische Daten wie beispielsweise Daten, die aus Blut- oder Speichelproben entnommen
            werden
        </li>
        <li class="adsimple-113004805">
            biometrische Daten (das sind Informationen zu psychischen, körperlichen oder
            verhaltenstypischen Merkmalen, die eine Person identifizieren können).<br />
            Gesundheitsdaten
        </li>
        <li class="adsimple-113004805">Daten zur sexuellen Orientierung oder zum Sexualleben</li>
    </ul>
    <h2 id="profiling" class="adsimple-113004805">Profiling</h2>
    <p>
        <strong class="adsimple-113004805">Begriffsbestimmung nach Artikel 4 der DSGVO</strong>
    </p>
    <p>Im Sinne dieser Verordnung bezeichnet der Ausdruck:</p>
    <blockquote>
        <p>
            <em>
                <strong class="adsimple-113004805">„Profiling“</strong> jede Art der automatisierten
                Verarbeitung personenbezogener Daten, die darin besteht, dass diese
                personenbezogenen Daten verwendet werden, um bestimmte persönliche Aspekte, die sich
                auf eine natürliche Person beziehen, zu bewerten, insbesondere um Aspekte bezüglich
                Arbeitsleistung, wirtschaftliche Lage, Gesundheit, persönliche Vorlieben,
                Interessen, Zuverlässigkeit, Verhalten, Aufenthaltsort oder Ortswechsel dieser
                natürlichen Person zu analysieren oder vorherzusagen;</em
            >
        </p>
    </blockquote>
    <p>
        <strong class="adsimple-113004805">Erläuterung:</strong> Beim Profiling werden verschiedene
        Informationen über eine Person zusammengetragen, um daraus mehr über diese Person zu
        erfahren. Im Webbereich wird Profiling häufig für Werbezwecke oder auch für
        Bonitätsprüfungen angewandt. Web- bzw. Werbeanalyseprogramme sammeln zum Beispiel Daten über
        Ihre Verhalten und Ihre Interessen auf einer Website. Daraus ergibt sich ein spezielles
        Userprofil, mit dessen Hilfe Werbung gezielt an eine Zielgruppe ausgespielt werden kann.
    </p>
    <p>&nbsp;</p>
    <h2 id="verantwortlicher" class="adsimple-113004805">Verantwortlicher</h2>
    <p>
        <strong class="adsimple-113004805">Begriffsbestimmung nach Artikel 4 der DSGVO</strong>
    </p>
    <p>Im Sinne dieser Verordnung bezeichnet der Ausdruck:</p>
    <blockquote>
        <p>
            <em>
                <strong class="adsimple-113004805">„Verantwortlicher“</strong> die natürliche oder
                juristische Person, Behörde, Einrichtung oder andere Stelle, die allein oder
                gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von
                personenbezogenen Daten entscheidet; sind die Zwecke und Mittel dieser Verarbeitung
                durch das Unionsrecht oder das Recht der Mitgliedstaaten vorgegeben, so kann der
                Verantwortliche beziehungsweise können die bestimmten Kriterien seiner Benennung
                nach dem Unionsrecht oder dem Recht der Mitgliedstaaten vorgesehen werden;</em
            >
        </p>
    </blockquote>
    <p>
        <strong class="adsimple-113004805">Erläuterung:</strong> In unserem Fall sind wir für die
        Verarbeitung Ihrer personenbezogenen Daten verantwortlich und folglich der
        &#8220;Verantwortliche&#8221;. Wenn wir erhobene Daten zur Verarbeitung an andere
        Dienstleister weitergeben, sind diese &#8220;Auftragsverarbeiter&#8221;. Dafür muss ein
        &#8220;Auftragsverarbeitungsvertrag (AVV)&#8221; unterzeichnet werden.
    </p>
    <p>&nbsp;</p>
    <h2 id="verarbeitung" class="adsimple-113004805">Verarbeitung</h2>
    <p>
        <strong class="adsimple-113004805">Begriffsbestimmung nach Artikel 4 der DSGVO</strong>
    </p>
    <p>Im Sinne dieser Verordnung bezeichnet der Ausdruck:</p>
    <blockquote>
        <p>
            <strong class="adsimple-113004805">
                <em>„Verarbeitung“</em>
            </strong>
            <em>
                jeden mit oder ohne Hilfe automatisierter Verfahren ausgeführten Vorgang oder jede
                solche Vorgangsreihe im Zusammenhang mit personenbezogenen Daten wie das Erheben,
                das Erfassen, die Organisation, das Ordnen, die Speicherung, die Anpassung oder
                Veränderung, das Auslesen, das Abfragen, die Verwendung, die Offenlegung durch
                Übermittlung, Verbreitung oder eine andere Form der Bereitstellung, den Abgleich
                oder die Verknüpfung, die Einschränkung, das Löschen oder die Vernichtung;</em
            >
        </p>
    </blockquote>
    <p>
        <strong class="adsimple-113004805">Anmerkung: </strong>Wenn wir in unserer
        Datenschutzerklärung von Verarbeitung sprechen, meinen wir damit jegliche Art von
        Datenverarbeitung. Dazu zählt, wie oben in der originalen DSGVO-Erklärung erwähnt, nicht nur
        das Erheben sondern auch das Speichern und Verarbeiten von Daten.
    </p>
    <p>Alle Texte sind urheberrechtlich geschützt.</p>
</div>
